import React from "react";
import moment from "moment";
import ReactModal from "react-modal";
import _ from "lodash";
import NavigationBar from "../Commons/NavigationBar";
import RadioGroup from "react-radio-group";
import { ToastContainer, ToastMessage } from "react-toastr";
import HSeparator from "../../img/commons/hseparator.png";
import * as request from "superagent";
import Diabetes from "./Diabetes";
import lock from "../../img/icons/general-icons/icon_lock.png";
import unlock from "../../img/icons/general-icons/icon_unlock.png";
import SkyLight from "react-skylight";
import warningData from "../../img/icons/general-icons/icon_warning.png";
import DefaultPicture from "../../img/commons/default_picture.png";
import { verifyAuth, getToken } from "../Commons/Authentication";
import Rslider from "../Commons/RangeSlider";
import { hashHistory } from "react-router";
import MiddleLine from "../../img/icons/general-icons/separator_icon.png";
import closeModal from "../../img/icons/general-icons/close.png";

const ToastMessageFactory = React.createFactory(ToastMessage.animation);
export default class MedicalInformation extends React.Component {
  arr() {
    let arr = [];
    for (var e = 0; e < 22; e++) {
      arr.push("data-input");
    }
    return arr;
  }
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      currentDiabetes: {},
      classNamecoltotal: "hide",
      classNamecolldl: "hide",
      classNamecolhdl: "hide",
      classNamecreatinina: "hide",
      classNametrigliceridos: "hide",
      classNameglicemia: "hide",
      classNamepeso: "hide",
      classNamepaparado: "hide",
      classNamepaparado_n: "hide",
      classNamepsentado: "hide",
      classNamepsentado_n: "hide",
      classNamefrecuencia: "hide",
      classNamealtura: "hide",
      numeroDocumento: "",
      selectedValue: "No",
      ansdepSelectedValue: "",
      dmSelectedValue: "",
      actcoSelectedValue: "",
      cpSelectedValue: "",
      movSelectedValue: "",
      phySelectedValue: "",
      movText: "",
      cpText: "",
      ansdepText: "",
      actcoText: "",
      ppaText: "",
      ppbText: "",
      psaText: "",
      psbText: "",
      imc: "",
      coltText: "",
      colLDLText: "",
      colHDLText: "",
      triText: "",
      creText: "",
      gliText: "",
      dmText: "",
      imcCalc: "",
      medicalData: {},
      decSelectedValue: "",
      happinessSelectedValue: "",
      transcendenceSelectedValue: "",
      worriedSelectedValue: "",
      satisfiedSelectedValue: "",
      presionParadoAlta: "",
      presionParadoBaja: "",
      presionSentadoAlta: "",
      presionSentadoBaja: "",
      frecuencia: "",
      temperatura: "",
      peso: "",
      altura: "",
      funcional: "",
      pabdominal: "",
      vop: "",
      itbi: "",
      itbd: "",
      balanceNeuroIMuscular: 0,
      balanceNeuroDMuscular: 0,
      tiempoCincoM: "",
      health: "",
      colesterolTotal: "",
      colesterolLDL: "",
      colesterolHDL: "",
      trigliceridos: "",
      creatinina: "",
      glicemia: "",
      dirty: false,
      patientData: {},
      patientImage: "",
      patientFullName: "",
      patientDocumentNumb: "",
      patientAge: "",
      patientIndetificationDoc: "",
      patientCreatedTime: "",
      patientDiabetico: "",
      patientGender: "",
      crclass: "medical-inputs",
      ctclass: "medical-inputs",
      clclas: "medical-inputs",
      chclass: "medical-inputs",
      paclass: "medical-inputs",
      psclass: "medical-inputs",
      notasText: "",
      createdDate: "",
      basicUnlockSymbol: "",
      emotiUnlockSymbol: "",
      activUnlockSymbol: "",
      physiUnlockSymbol: "",
      examnUnlockSymbol: "",
      diabeUnlockSymbol: "",
      positionMedical: "",
      patient: "",
      readMode: "medical-content-show hide",
      editionMode: "medical-content",
      disableInputsState: false,
      incPass: "",
      errorMessage: "",
      control: "",
      duracionDm: "",
      hba1c: "",
      fevi: "",
      fase: "",
      funcional: "",
      pieDiabeValue: "",
      selectedAlb: "",
      IAMValue: "",
      ICCValue: "",
      ACVValue: "",
      AngPrev: "",
      ojosValue: "",
      corazonValue: "",
      rinonValue: "",
      neuroValue: "",
      cerebroValue: "",
      vascularValue: "",
      metabValue: "",
      inpErrorClass: "input-password-confirm",
      IMCRange: "",
      perAbdRange: "",
      presArRange: "",
      presPRange: "",
      presSRange: "",
      vopRange: "",
      fcRange: "",
      itbiRange: "",
      itbdRange: "",
      coltRange: "",
      movRange: "",
      dolRange: "",
      ansRange: "",
      actRange: "",
      cupRange: "",
      metsRange: "",
      satRange: "",
      preRange: "",
      conRange: "",
      depRange: "",
      felRange: "",
      trigRange: "",
      collRange: "",
      colhRange: "",
      hba1cRange: "",
      albuRange: "",
      creatRange: "",
      balIzRange: "",
      balDeRange: "",
      indViRange: "",
      indCaRange: "",
      resFnRange: "",
      balAfRange: "",
      edadARange: "",
      edadBRange: "",
      ojosERange: "",
      rinonRange: "",
      neuroRange: "",
      metabRange: "",
      corazRange: "",
      cerebRange: "",
      vascuRange: "",
      hospiRange: "",
      superRange: "",
      duraDRange: "",
      tabaqRange: "",
      iamRange: "",
      iccRange: "",
      acvRange: "",
      angRange: "",
      sistolicaRange: "",
      clasFRange: "",
      clasSRange: "",
      feviVRange: "",
      evaPDRange: "",
      overlymain: "hide",
      hba1cClass: "severity-input",
      all: {},
      currentRol: "",
      timeClass: "severity-input",
      showAddControl: true,
      medicalsCore2: {},
      arr: this.arr()
    };
  }

  componentWillMount() {
    this.findPatientData();
    this.findMedicalData();
    this.loadMedicalControlTabs();
    this.findDiabetesControlTabs();
    this.findDiabetes();
    this.loadUserData();
  }
  handleDelete(e) {
    console.log("click", e.currentTarget.dataset.value, e.target.id);
  }
  loadUserData() {
    let endpoint = "api/v1/user/find";
    request
      .get(endpoint)
      .set("Authorization", `Bearer ${getToken()}`)
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err) console.log("nologueado");
        else {
          if (!res.body.rol) {
            this.setState({ moduleDiabetes: false, moduleMedical: false });
          } else if (!res.body.rol[0]) {
            this.setState({ moduleDiabetes: false, moduleMedical: false });
          } else {
            if (res.body.rol[0].nombre) {
              if (
                res.body.rol[0].nombre === "admin" ||
                res.body.rol[0].nombre === "medico_sicor"
              ) {
                this.setState({
                  moduleDiabetes: true,
                  moduleMedical: true,
                  currentRol: res.body.rol[0].nombre
                });
              } else if (res.body.rol[0].nombre === "enfermero") {
                this.setState({
                  moduleDiabetes: false,
                  moduleMedical: false,
                  currentRol: res.body.rol[0].nombre
                });
              }
            }
          }
        }
      });
  }

  findDiabetesControlTabs() {
    let endpoint = "api/v1/diabetes/findDiabetesById";
    request
      .get(endpoint)
      .query({ id: this.props.params.patient, limit: 15 })
      .set("Authorization", "Bearer " + getToken())
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err || !res.ok) {
          console.log("Error: ", err);
        } else {
          this.setState({ diabetes: res.body });
        }
      });
  }

  findDiabetes() {
    let identificacion = this.props.params.patient;
    request
      .get("api/v1/diabetes/findDiabetesByIdOne/")
      .query({ id: identificacion })
      .set("Authorization", "Bearer " + getToken())
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err || !res.ok) {
          // console.log('Error: ', err)
        } else {
          let diabetesInfo = res.body;
          // console.log(diabetesInfo.control, 267, this.state.control)
          try {
            if (!res.body) {
              return
            }
          } catch (e) {

          }
          if (diabetesInfo.control != this.state.control) {
            diabetesInfo.fevi = "";
            diabetesInfo.clasificacionFase = "";
            diabetesInfo.claseFuncional = "";
            diabetesInfo.hba1c = "";
            let date = this.state.timestamp
              ? this.state.timestamp
              : moment().format("x");
            request
              .get("api/v1/appointment/")
              .query({ identificacion: identificacion, TIMESTAMP: date })
              .set("Authorization", "Bearer " + getToken())
              .set("Accept", "application/json")
              .end((err, temp) => {
                if (err || !temp.ok) {
                  console.log("appointment response error");
                } else {
                  if (temp.body.TIMESTAMP * 1000 < diabetesInfo.timestamp) {
                    return;
                  } else {
                    let temp_d = temp.body;
                    this.setState({ hba1c: temp_d.hba1c });
                  }
                }
              });
          }
          this.setState({
            diabControl: diabetesInfo.control,
            currentDiabetes: diabetesInfo,
            duracionDm: diabetesInfo.duracionDm,
            hba1c: diabetesInfo.hba1c,
            _id: diabetesInfo._id,
            fevi: diabetesInfo.fevi,
            fase: diabetesInfo.clasificacionFase,
            funcional: diabetesInfo.claseFuncional,
            pieDiabeValue: diabetesInfo.pieDiabeValue,
            selectedAlb: this.riesgosBooleanToStr(diabetesInfo.albuminuria),
            IAMValue: this.riesgosBooleanToStr(diabetesInfo.iamPrevDm),
            ICCValue: this.riesgosBooleanToStr(diabetesInfo.iccPrev),
            ACVValue: this.riesgosBooleanToStr(diabetesInfo.acvPrev),
            AngPrev: this.riesgosBooleanToStr(diabetesInfo.anginaPre),
            ojosValue: diabetesInfo.ojos,
            corazonValue: diabetesInfo.corazon,
            rinonValue: diabetesInfo.rinon,
            neuroValue: diabetesInfo.neuropatia,
            cerebroValue: diabetesInfo.cerebroVascular,
            vascularValue: diabetesInfo.vascularPeriferico,
            metabValue: diabetesInfo.metabolico
          });
        }
      });
  }

  findPatientData() {
    let endpoint = `api/v1/patient/find?numeroDocumento=${
      this.props.params.patient
      }`;
    request
      .get(endpoint)
      .set("Authorization", `Bearer ${getToken()}`)
      .set("Accept", "application/json")
      .end((err, res) => {
        if (!_.isEmpty(res.body[0])) {
          let patientInfo = res.body[0];
          var birthday = new Date(
            patientInfo.fechaNacimiento
              .split("/")
              .reverse()
              .join("-")
          );
          var ageDifMs = Date.now() - birthday.getTime();
          var ageDate = new Date(ageDifMs);
          var age = Math.abs(ageDate.getUTCFullYear() - 1970);
          var date_muerte = moment(patientInfo.date_muerte).format(
            "DD-MM-YYYY"
          );
          var image = patientInfo.image ? patientInfo.image : DefaultPicture;
          this.setState({
            patientIdentificationDoc:
              patientInfo.tipoDocumento + " " + patientInfo.numeroDocumento,
            patientImage: image,
            patientGender: patientInfo.genero,
            promedioSistolica: "",
            patientFullName: `${patientInfo.nombres} ${patientInfo.apellidos}`,
            patientAge: age,
            patientGender: patientInfo.genero,
            patientDiabetico: patientInfo.diabetico,
            patientCreatedTime: patientInfo.timestamp,
            muerto: patientInfo.muerto,
            date_muerte: date_muerte
          });
        } else {
          // console.log('Error: ' + err)
        }
      });
  }
  mesesFinishDate(meses, arr) {
    console.log(meses, arr);
  }
  findCore2Data() {
    let identificacion = this.props.params.patient;
    // let date = (this.state.createdDate == '' || this.state.createdDate == null || typeof this.state.createdDate == 'undefined' ) ? this.state.patientCreatedTime : this.state.createdDate
    let date = this.state.timestamp
      ? this.state.timestamp
      : moment().format("x");
    request
      .get("api/v1/appointment/")
      .query({ identificacion: identificacion, TIMESTAMP: date })
      .set("Authorization", "Bearer " + getToken())
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err || !res.ok) {
          console.log("appointment response error");
        } else {
          // console.log('appointment response ', res.body)
          try {
            if (res.body.Message) {
            } else {
              delete res.body._id;
              var newArray = this.state;
              if (res.body.TIMESTAMP * 1000 < this.state.timestamp) return;
              let d = _.merge(newArray, res.body);
              console.log(res.body);
              let arr = d.arr;
              let meses = moment().diff(
                moment(d.TIMESTAMP * 1000, "x"),
                "months"
              );
              if (meses < 3) {
                arr[0] = "data-input";
                arr[1] = "data-input";
                arr[2] = "data-input";
                arr[3] = "data-input";
                arr[4] = "data-input";
                arr[5] = "data-input";
                arr[6] = "data-input";
                arr[15] = "data-input";
                arr[16] = "data-input";
                arr[17] = "data-input";
                arr[18] = "data-input";
                arr[19] = "data-input";
                arr[20] = "data-input";
              }
              d.arr = arr;
              this.setState(d);
            }
          } catch (e) {
            throw e;
          }
        }
      });
  }

  lockEdition(timestamp) {
    console.log("lock")
    let dayDif = moment().diff(moment(timestamp, "x").format(), "hours");
    let lockImage = dayDif >= 12 ? lock : unlock;
    let position = dayDif >= 12 ? "absolute" : "";
    let disabledInpt = dayDif >= 12 ? true : false;
    this.setState({
      basicUnlockSymbol: lockImage,
      emotiUnlockSymbol: lockImage,
      activUnlockSymbol: lockImage,
      physiUnlockSymbol: lockImage,
      examnUnlockSymbol: lockImage,
      diabeUnlockSymbol: lockImage,
      notesUnlockSymbol: lockImage,
      positionPhysical: position,
      positionExamns: position,
      positionDiabetes: position,
      positionActivity: position,
      positionEmotional: position,
      positionMedical: position,
      positionNotes: position,
      disableInputsState: disabledInpt
    });
  }
  mesesFinish(meses) {
    let monthsFinished = [];
    for (var o = 0; o < 22; o++) {
      if (meses >= 3) {
        monthsFinished.push("data-input red");
      } else {
        monthsFinished.push("data-input");
      }
    }
    if (meses >= 3) {
      this.refs.container.error(
        "Los campos de texto en rojo tienen más de 3 meses de antigüedad, actualizar datos.",
        "",
        {
          closeButton: true,
          timeOut: 30000
        }
      );
    }
    return monthsFinished;
  }
  findMedicalData() {
    let identificacion = this.props.params.patient;
    request
      .get("api/v1/medical/findMedicalByIdOne")
      .query({ id: identificacion })
      .set("Authorization", "Bearer " + getToken())
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err || !res.ok) {
          // console.log('Error: ', err)
        } else {
          if (!res.body) {
            return
          }
          let medicalInfo = res.body;
          // console.log(medicalInfo.timestamp, 'timestamp')
          let meses = moment().diff(
            moment(medicalInfo.timestamp, "x"),
            "months"
          );
          let ppaltaText =
            medicalInfo.presionParadoAlta < 90 ||
              medicalInfo.presionParadoAlta > 220
              //sistoleParado
              ? "La presión parado alta debe ser un valor entre 90 y 220"
              : "";
          let ppbajaText =
            medicalInfo.presionParadoBaja < 60 ||
              medicalInfo.presionParadoBaja > 120
              //diastoleParado
              ? "La presión parado baja debe ser un valor entre 60 y 120"
              : "";
          let psaltaText =
            medicalInfo.presionSentadoAlta < 90 ||
              medicalInfo.presionSentadoAlta > 220
              //sistoleSentado
              ? "La presión sentado alta debe ser un valor entre 90 y 220"
              : "";
          let psbajaText =
            medicalInfo.presionSentadoBaja < 60 ||
              medicalInfo.presionSentadoBaja > 120
              //diastoleSentado
              ? "La presión sentado baja debe ser un valor entre 60 y 120"
              : "";
          let balanceText =
            medicalInfo.balanceNeuroMuscular < 10 ||
              medicalInfo.balanceNeuroMuscular > 42
              ? "El balance debe ser un valor entre 22 y 42"
              : "";
          let frecuenciaT =
            medicalInfo.frecuencia < 50 || medicalInfo.frecuencia > 90
              ? "La frecuencia debe ser un valor entre 50 y 90 LPM"
              : "";
          let pesoText =
            medicalInfo.peso < 50 || medicalInfo.peso > 110
              ? "El peso debe ser un entre 50 y 110 Kg"
              : "";
          let itbiz =
            medicalInfo.itbIzquierdo < 0.5 || medicalInfo.itbIzquierdo > 1.5
              ? "El itb izquierdo debe ser un numero entre 0.5 y 1.5"
              : "";
          let itbde =
            medicalInfo.itbDerecho < 0.5 || medicalInfo.itbDerecho > 1.5
              ? "El itb derecho debe ser un numero entre 0.5 y 1.5"
              : "";
          let vop =
            medicalInfo.vop < 4 || medicalInfo.vop > 15
              ? "El vop debe ser un numero entre 4 y 15"
              : "";
          let coltotText =
            medicalInfo.colesterolTotal < 60 ||
              medicalInfo.colesterolTotal > 600
              ? "El colesterol total debe ser un valor entre 60 y 600"
              : "";
          let colHDLText =
            medicalInfo.colesterolHDL < 20 || medicalInfo.colesterolHDL > 120
              ? "El colesterol HDL debe ser un valor entre 20 y 120"
              : "";
          let colLDLText =
            medicalInfo.colesterolLDL < 40 || medicalInfo.colesterolHDL > 400
              ? "El colesterol LDL debe ser un valor entre 40 y 400"
              : "";
          let trigliText =
            medicalInfo.trigliceridos < 40 || medicalInfo.trigliceridos > 1200
              ? "El valor de los trigliceridos debe ser entre 40 y 1200"
              : "";
          let creatiText =
            medicalInfo.creatinina < 0.3 || medicalInfo.creatinina > 5
              ? "El valor de la creatinina debe estár entre 0.3 y 5"
              : "";
          let glicemText =
            medicalInfo.glicemia < 40 || medicalInfo.glicemia > 700
              ? "El valor de la glicemia debe estár entre 40 y 700"
              : "";
          let peso = medicalInfo.peso;
          let altura = medicalInfo.altura / 100;
          let imc = Math.floor(peso / (altura * altura));

          let dayDif = moment().diff(
            moment(medicalInfo.timestamp, "x").format(),
            "days"
          );
          let lockImage = dayDif >= 1 ? lock : unlock;
          let position = dayDif >= 1 ? "absolute" : "";
          let disabledInpt = dayDif >= 1 ? true : false;
          let controlNumber = medicalInfo.control;
          let creation = medicalInfo.modificadoPor;

          this.setState({
            medicalData: medicalInfo,
            presionParadoAlta: medicalInfo.presionParadoAlta,
            presionParadoBaja: medicalInfo.presionParadoBaja,
            presionSentadoAlta: medicalInfo.presionSentadoAlta,
            presionSentadoBaja: medicalInfo.presionSentadoBaja,
            frecuencia: medicalInfo.frecuencia,
            temperatura: medicalInfo.temperatura,
            peso: medicalInfo.peso,
            altura: medicalInfo.altura,
            imc: imc,
            balanceNeuroIMuscular: medicalInfo.balanceNeuroMuscular,
            balanceNeuroDMuscular: medicalInfo.balanceNeuroMuscularD,
            ppaText: ppaltaText,
            ppbText: ppbajaText,
            psaText: psaltaText,
            psbText: psbajaText,
            textBalance: balanceText,
            textPeso: pesoText,
            textFrecuencia: frecuenciaT,
            textVOP: vop,
            textITBI: itbiz,
            textITBD: itbde,
            coltText: coltotText,
            colLDLText: colLDLText,
            colHDLText: colHDLText,
            triText: trigliText,
            creText: creatiText,
            gliText: glicemText,
            tiempoCincoM: medicalInfo.tiempoCincoM,
            health: medicalInfo.health,
            colesterolTotal: medicalInfo.colesterolTotal,
            colesterolLDL: medicalInfo.colesterolLDL,
            colesterolHDL: medicalInfo.colesterolHDL,
            trigliceridos: medicalInfo.trigliceridos,
            creatinina: medicalInfo.creatinina,
            glicemia: medicalInfo.glicemia,
            pabdominal: medicalInfo.perimetroAbdominal,
            itbi: medicalInfo.itbIzquierdo,
            itbd: medicalInfo.itbDerecho,
            vop: medicalInfo.vop,
            notasText: medicalInfo.observaciones,
            createdDate: medicalInfo.timestamp,
            basicUnlockSymbol: lockImage,
            emotiUnlockSymbol: lockImage,
            activUnlockSymbol: lockImage,
            physiUnlockSymbol: lockImage,
            examnUnlockSymbol: lockImage,
            diabeUnlockSymbol: lockImage,
            notesUnlockSymbol: lockImage,
            positionPhysical: position,
            positionExamns: position,
            positionDiabetes: position,
            positionActivity: position,
            positionEmotional: position,
            positionMedical: position,
            positionNotes: position,
            disableInputsState: disabledInpt,
            patient: medicalInfo.patient,
            readMode: "medical-content-show hide",
            editionMode: "medical-content",
            control: controlNumber,
            creadoPor: creation,
            timestamp: medicalInfo.timestamp,
            creationDate: moment(medicalInfo.timestamp, "x").format(
              "DD/MM/YYYY"
            ),
            meses: meses
          });
        }
      });
  }

  smokeSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.fuma = value;
    this.setState({ medicalData: newMedicalData });
  }

  phySelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.mets = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
    let phyArray = [
      " ",
      "Inactivo o poca actividad distinta a las actividades cotidianas",
      "Participación en actividades, 2 a 5 veces por semana, que requieren pequeños esfuerzos que resultan en leves incrementos en la respiración y el ritmo cardiaco por al menos diez minutos cada vez.",
      "Aeróbicos como caminar con energía, trotar o correr, montar bicicleta, nadar o practicar un deporte vigoroso por: 20 a 60 minutos por semana.",
      "Aeróbicos como caminar con energía, trotar o correr, montar bicicleta, nadar o practicar un deporte vigoroso por: 1 a 3 horas por semana.",
      "Aeróbicos como caminar con energía, trotar o correr, montar bicicleta, nadar o practicar un deporte vigoroso por: más de 3 horas por semana."
    ];
    this.setState({ phyText: phyArray[value] });
  }

  movSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.movilidad = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
    let moveArray = [
      " ",
      "No tengo problemas para caminar",
      "Tengo algunos problemas para caminar",
      "Tengo que estar en la cama"
    ];
    this.setState({ movText: moveArray[value] });
  }

  cpSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.cuidadoPersonal = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
    let cpArray = [
      " ",
      "No tengo problemas con el cuidado personal",
      "Tengo algunos problemas para lavarme o vestirme",
      "Soy incapaz de lavarme o vestirme"
    ];
    this.setState({ cpText: cpArray[value] });
  }

  ansdepSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.ansiedad = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
    let ansdepArray = [
      " ",
      "No estoy ansioso ni deprimido",
      "Estoy moderadamente ansioso o deprimido",
      "Estoy muy ansioso o deprimido"
    ];
    this.setState({ ansdepText: ansdepArray[value] });
  }

  actcoSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.actividadesCotidianas = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
    let actcoArray = [
      " ",
      "No tengo problemas para realizar mis actividades cotidianas",
      "Tengo algunos problemas para realizar mis actividades cotidianas",
      "Soy incapaz de realizar mis actividades cotidianas"
    ];
    this.setState({ actcoText: actcoArray[value] });
  }

  dmSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.dolor = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
    let dmArray = [
      " ",
      "No tengo dolor ni malestar",
      "Tengo moderado dolor o malestar",
      "Tengo mucho dolor o malestar"
    ];
    this.setState({ dmText: dmArray[value] });
  }

  satisfiedSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.satisfaccion = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
  }

  happinessSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.feliz = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
  }

  transcendenceSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.depresion = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
  }

  worriedSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.preocupacion = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
  }

  decSelection(value) {
    let newMedicalData = this.state.medicalData;
    newMedicalData.decaido = value;
    this.setState({ medicalData: newMedicalData, dirty: true });
  }

  presionParadoAltaChange() {
    let arr = this.state.arr;
    arr[0] = "data-input";
    this.setState({
      dirty: true,
      presionParadoAlta: this.refs.paparado.value,
      paclassName: "medical-inputs"
    });
    if (
      Number(this.refs.paparado.value) > 220 ||
      Number(this.refs.paparado.value) < 90
    ) {
      this.setState({
        ppaText: "La presión parado alta debe ser un valor entre 90 y 220"
      });
    } else if (isNaN(Number(this.refs.paparado.value))) {
      this.setState({ ppaText: "debe  s introducir un numero" });
    } else {
      this.setState({ ppaText: "" });
    }
    this.setState({ arr: arr });
  }

  presionParadoBajaChange() {
    let arr = this.state.arr;
    arr[1] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      presionParadoBaja: this.refs.paparado_n.value
    });
    if (
      Number(this.refs.paparado_n.value) > 120 ||
      Number(this.refs.paparado_n.value) < 60
    ) {
      this.setState({
        ppbText: "La presión parado baja debe ser un valor entre 60 y 120"
      });
    } else if (isNaN(Number(this.refs.paparado_n.value))) {
      this.setState({ ppbText: "debes introducir un numero" });
    } else {
      this.setState({ ppbText: "" });
    }
  }

  presionSentadoAltaChange() {
    let arr = this.state.arr;
    arr[2] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      presionSentadoAlta: this.refs.psentado.value,
      psclassName: "medical-inputs"
    });
    if (
      Number(this.refs.psentado.value) > 220 ||
      Number(this.refs.psentado.value) < 90
    ) {
      this.setState({
        psaText: "La presión sentado alta debe ser un valor entre 90 y 220"
      });
    } else if (isNaN(Number(this.refs.psentado.value))) {
      this.setState({ psaText: "debes introducir un numero" });
    } else {
      this.setState({ psaText: "" });
    }
  }

  presionSentadoBajaChange() {
    let arr = this.state.arr;
    arr[3] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      presionSentadoBaja: this.refs.psentado_n.value
    });
    if (
      Number(this.refs.psentado_n.value) > 120 ||
      Number(this.refs.psentado_n.value) < 60
    ) {
      this.setState({
        psbText: "La presión sentado baja debe ser un valor entre 60 y 120"
      });
    } else if (isNaN(Number(this.refs.psentado_n.value))) {
      this.setState({ psbText: "debes introducir un numero" });
    } else {
      this.setState({ psbText: "" });
    }
  }

  handleObservaciones() {
    this.setState({ notasText: this.refs.observaciones.value, dirty: true });
  }

  frecuenciaChange() {
    let arr = this.state.arr;
    arr[4] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, frecuencia: this.refs.frecuencia.value });
    if (
      Number(this.refs.frecuencia.value) > 90 ||
      Number(this.refs.frecuencia.value) < 50
    ) {
      this.setState({
        textFrecuencia: "La frecuencia debe ser un valor entre 50 y 90 LPM"
      });
    } else if (isNaN(Number(this.refs.frecuencia.value))) {
      this.setState({ textFrecuencia: "debes introducir un numero" });
    } else {
      this.setState({ textFrecuencia: "" });
    }
  }

  pAbdominalChange() {
    let arr = this.state.arr;
    arr[7] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, pabdominal: this.refs.pabdominal.value });
  }

  vopChange() {
    let arr = this.state.arr;
    arr[12] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, vop: this.refs.vop.value });
    if (Number(this.refs.vop.value) > 15 || Number(this.refs.vop.value) < 4) {
      this.setState({ textVOP: "El vop debe estar entre 4 y 15 " });
    } else if (isNaN(Number(this.refs.vop.value))) {
      this.setState({ textVOP: "Debes introducir un numero" });
    } else {
      this.setState({ textVOP: "" });
    }
  }

  itbiChange() {
    let arr = this.state.arr;
    arr[10] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, itbi: this.refs.itbi.value });
    if (
      Number(this.refs.itbi.value) > 1.5 ||
      Number(this.refs.itbi.value) < 0.5
    ) {
      this.setState({
        textITBI: "El itb izquierdo debe estar entre 0.5 y 1.5 "
      });
    } else if (isNaN(Number(this.refs.itbi.value))) {
      this.setState({ textITBI: "Debes introducir un número" });
    } else {
      this.setState({ textITBI: "" });
    }
  }

  itbdChange() {
    let arr = this.state.arr;
    arr[11] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, itbd: this.refs.itbd.value });
    if (
      Number(this.refs.itbd.value) > 1.5 ||
      Number(this.refs.itbd.value) < 0.5
    ) {
      this.setState({ textITBD: "El itb derecho debe estar entre 0.5 y 1.5 " });
    } else if (isNaN(Number(this.refs.itbd.value))) {
      this.setState({ textITBD: "Debes introducir un número" });
    } else {
      this.setState({ textITBD: "" });
    }
  }

  temperaturaChange() {
    let arr = this.state.arr;
    arr[14] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, temperatura: this.refs.temperatura.value });
  }

  pesoChange() {
    let arr = this.state.arr;
    arr[5] = "data-input";
    this.setState({ arr: arr });
    let peso = this.refs.peso.value;
    let altura = this.refs.altura.value / 100;
    let imc = Math.floor(peso / (altura * altura));

    this.setState({ dirty: true, peso: this.refs.peso.value, imc: imc });
    if (
      Number(this.refs.peso.value) > 110 ||
      Number(this.refs.peso.value) < 50
    ) {
      this.setState({ textPeso: "El peso debe ser un entre 50 y 110 Kg" });
    } else if (isNaN(Number(this.refs.peso.value))) {
      this.setState({ textPeso: "debes introducir un numero" });
    } else {
      this.setState({ textPeso: "" });
    }
  }

  alturaChange() {
    let arr = this.state.arr;
    arr[6] = "data-input";
    this.setState({ arr: arr });
    let peso = this.refs.peso.value;
    let altura = this.refs.altura.value / 100;
    let imc = Math.floor(peso / (altura * altura));
    this.setState({ dirty: true, altura: this.refs.altura.value, imc: imc });
  }

  balanceNeuroIMuscularChange() {
    let arr = this.state.arr;
    arr[8] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      balanceNeuroIMuscular: this.refs.balancen.value
    });
    if (
      Number(this.refs.balancen.value) > 42 ||
      Number(this.refs.balancen.value) < 10
    ) {
      this.setState({
        textBalanceI: "El balance debe ser un valor entre 10 y 42"
      });
    } else if (isNaN(Number(this.refs.balancen.value))) {
      this.setState({ textBalanceI: "Debes introducir un numero" });
    } else {
      this.setState({ textBalanceI: "" });
    }
  }

  balanceNeuroDMuscularChange() {
    let arr = this.state.arr;
    arr[9] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      balanceNeuroDMuscular: this.refs.balancend.value
    });
    if (
      Number(this.refs.balancend.value) > 42 ||
      Number(this.refs.balancend.value) < 10
    ) {
      this.setState({
        textBalanceI: "El balance debe ser un valor entre 10 y 42"
      });
    } else if (isNaN(Number(this.refs.balancend.value))) {
      this.setState({ textBalanceI: "Debes introducir un numero" });
    } else {
      this.setState({ textBalanceI: "" });
    }
  }

  tiempoCincoMChange() {
    let arr = this.state.arr;
    arr[13] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, tiempoCincoM: this.refs.meters.value });
  }

  healthChange(value) {
    this.setState({ dirty: true, health: value });
  }
  healthInputChange() {
    this.setState({ dirty: true, health: this.refs.health.value });
  }
  colesterolTotalChange() {
    let arr = this.state.arr;
    arr[15] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      colesterolTotal: this.refs.coltotal.value,
      ctclassName: "medical-inputs"
    });
    if (
      Number(this.refs.coltotal.value) > 600 ||
      Number(this.refs.coltotal.value) < 60
    ) {
      this.setState({
        coltText: "El colesterol total debe ser un valor entre 60 y 600"
      });
    } else if (isNaN(Number(this.refs.coltotal.value))) {
      this.setState({ coltText: "Debes introducir un numero" });
    } else {
      this.setState({ coltText: "" });
    }
    let col = this.refs.coltotal.value;
    let vldl = Number(this.refs.trigliceridos.value) / 5;
    let resta = vldl + Number(this.refs.colhdl.value);
    let ldl = Math.round((col - resta) * 100) / 100;
    this.setState({ colesterolLDL: ldl });

    console.log(ldl);
  }

  colesterolLDLChange() {
    let arr = this.state.arr;
    arr[16] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      colesterolLDL: this.refs.colldl.value,
      clclassName: "medical-inputs"
    });
    if (
      Number(this.refs.colldl.value) > 400 ||
      Number(this.refs.colldl.value) < 40
    ) {
      this.setState({
        colLDLText: "El colesterol LDL debe ser un valor entre 40 y 400"
      });
    } else if (isNaN(Number(this.refs.colldl.value))) {
      this.setState({ colLDLText: "Debes introducir un numero" });
    } else {
      this.setState({ colLDLText: "" });
    }
  }

  colesterolHDLChange() {
    let arr = this.state.arr;
    arr[17] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      colesterolHDL: this.refs.colhdl.value,
      chclassName: "medical-inputs"
    });
    if (
      Number(this.refs.colhdl.value) > 120 ||
      Number(this.refs.colhdl.value) < 20
    ) {
      this.setState({
        colHDLText: "El colesterol HDL debe ser un valor entre 20 y 120"
      });
    } else if (isNaN(Number(this.refs.colhdl.value))) {
      this.setState({ colHDLText: "Debes introducir un numero" });
    } else {
      this.setState({ colHDLText: "" });
    }
    let col = this.refs.coltotal.value;
    let vldl = Number(this.refs.trigliceridos.value) / 5;
    let resta = vldl + Number(this.refs.colhdl.value);
    let ldl = Math.round((col - resta) * 100) / 100;
    this.setState({ colesterolLDL: ldl });
  }

  trigliceridosChange() {
    let arr = this.state.arr;
    arr[19] = "data-input";
    // colesterol total - (trigliceridos /5 + hdl )
    let col = this.refs.coltotal.value;
    let vldl = Number(this.refs.trigliceridos.value) / 5;
    let resta = vldl + Number(this.refs.colhdl.value);
    let ldl = Math.round((col - resta) * 100) / 100;
    this.setState({ colesterolLDL: ldl });

    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      trigliceridos: this.refs.trigliceridos.value
    });
    if (
      Number(this.refs.trigliceridos.value) > 1200 ||
      Number(this.refs.trigliceridos.value) < 40
    ) {
      this.setState({
        triText: "El valor de los triglicéridos debe estár entre 40 y 1200"
      });
    } else if (isNaN(Number(this.refs.trigliceridos.value))) {
      this.setState({ triText: "Debes introducir un numero" });
    } else {
      this.setState({ triText: "" });
    }
  }

  creatininaChange() {
    let arr = this.state.arr;
    arr[18] = "data-input";
    this.setState({ arr: arr });
    this.setState({
      dirty: true,
      creatinina: this.refs.creatinina.value,
      crclassName: "medical-inputs"
    });
    if (
      Number(this.refs.creatinina.value) > 5 ||
      Number(this.refs.creatinina.value) < 0.3
    ) {
      this.setState({ creText: "La creatinina debe estár entre 0.3 y 5" });
    } else if (isNaN(Number(this.refs.creatinina.value))) {
      this.setState({ creText: "Debes introducir un numero" });
    } else {
      this.setState({ creText: "" });
    }
  }

  glicemiaChange() {
    let arr = this.state.arr;
    arr[20] = "data-input";
    this.setState({ arr: arr });
    this.setState({ dirty: true, glicemia: this.refs.glicemia.value });
    if (
      Number(this.refs.glicemia.value) > 700 ||
      Number(this.refs.glicemia.value) < 40
    ) {
      this.setState({ gliText: "La glicemia debe estár entre 40 y 700" });
    } else if (isNaN(Number(this.refs.glicemia.value))) {
      this.setState({ gliText: "Debes introducir un numero" });
    } else {
      this.setState({ gliText: "" });
    }
  }

  diabetesFieldsStyle(fieldclassName) {
    if (fieldclassName === true) {
      if (this.refs.psentado.value === "") {
        this.setState({ psclassName: "medical-inputs medical-inputs-error" });
      }
      if (this.refs.paparado.value === "") {
        this.setState({ paclassName: "medical-inputs medical-inputs-error" });
      }
      if (this.refs.coltotal.value === "") {
        this.setState({ ctclassName: "medical-inputs medical-inputs-error" });
      }
      if (this.refs.colldl.value === "") {
        this.setState({ clclassName: "medical-inputs medical-inputs-error" });
      }
      if (this.refs.colhdl.value === "") {
        this.setState({ chclassName: "medical-inputs medical-inputs-error" });
      }
      if (this.refs.creatinina.value === "") {
        this.setState({ crclassName: "medical-inputs medical-inputs-error" });
      }
    }
  }

  saveMedicalData(e) {
    console.log("state: ", this.state);
    const {
      currentRol,
      patientDiabetico,
      colesterolHDL,
      colesterolLDL,
      colesterolTotal,
      creatinina,
      glicemia,
      trigliceridos
    } = this.state;
    if (
      currentRol != "enfermero" &&
      // patientDiabetico &&
      colesterolHDL > 0 &&
      colesterolLDL > 0 &&
      colesterolTotal > 0 &&
      creatinina > 0 &&
      glicemia > 0 &&
      trigliceridos > 0
    ) {
      //   return false;
      if (!_.isEmpty(this.state.medicalData._id)) {
        let str = this.state.medicalData._id;
        let length = str.length;
        if (length < 24) this.saveMedicalInformation(true);
        else this.updateMedicalInformation(true);
      } else {
        this.saveMedicalInformation(true);
      }
    } else {
      console.log(currentRol)
      if (
        currentRol == "enfermero" &&
        // patientDiabetico &&
        colesterolHDL > 0 &&
        colesterolLDL > 0 &&
        colesterolTotal > 0 &&
        creatinina > 0 &&
        glicemia > 0 &&
        trigliceridos > 0
      ) {
        //si es enfermero
        console.log('es enfermero')
        if (!_.isEmpty(this.state.medicalData._id)) {
          let str = this.state.medicalData._id;
          let length = str.length;
          if (length < 24) this.saveMedicalInformation();
          else this.updateMedicalInformation();
        } else {
          this.saveMedicalInformation();
        }
      } else if (currentRol == 'enfermero') {
        if (!_.isEmpty(this.state.medicalData._id)) {
          let str = this.state.medicalData._id;
          let length = str.length;
          if (length < 24) this.saveMedicalInformation();
          else this.updateMedicalInformation();
        } else {
          this.saveMedicalInformation();
        }
      }
      else {
        // if (!patientDiabetico) {
        //   //si no es diabetico
        //   if (!_.isEmpty(this.state.medicalData._id)) {
        //     let str = this.state.medicalData._id;
        //     let length = str.length;
        //     if (length < 24) this.saveMedicalInformation();
        //     else this.updateMedicalInformation();
        //   } else {
        //     this.saveMedicalInformation();
        //   }
        // } else { 
        let f = "";
        f += colesterolHDL == 0 || colesterolHDL == null ? "Colesterol HDL, " : "";
        f += colesterolLDL == 0 || colesterolLDL == null ? "Colesterol LDL, " : "";
        f += colesterolTotal == 0 || colesterolTotal == null ? "Colesterol total, " : "";
        f += creatinina == 0 || creatinina == null ? "Creatinina, " : "";
        f += glicemia == 0 || glicemia == null ? "Glicemia, " : "";
        f += trigliceridos == 0 || trigliceridos == null ? "Trigliceridos" : "";
        f = f.trim();

        this.refs.container.error(`Faltan datos ${f}`, "", {
          closeButton: true
        });
        // }
      }
    }
  }

  unlockData(e) {
    e.preventDefault();
    request
      .post("api/v1/user/unlock")
      .set("Authorization", "Bearer " + getToken())
      .send({ password: this.refs.passwordConfirm.value })
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err || res.status === 500) {
          this.refs.container.error("Contraseña incorrecta", "", {
            closeButton: true
          });
          this.setState({
            incPass: "Contraseña incorrecta",
            errorMessage: "error-pass-modal",
            inpErrorClass: "input-password-confirm-error"
          });
        } else if (res.status === 200) {
          this.refs.container.success("Modo edición habilitado", "", {
            closeButton: true
          });
          this.setState({
            notesUnlockSymbol: unlock,
            positionNotes: "",
            diabeUnlockSymbol: unlock,
            positionDiabetes: "",
            examnUnlockSymbol: unlock,
            positionExamns: "",
            activUnlockSymbol: unlock,
            positionActivity: "",
            emotiUnlockSymbol: unlock,
            positionEmotional: "",
            physiUnlockSymbol: unlock,
            positionPhysical: "",
            basicUnlockSymbol: unlock,
            positionMedical: "",
            disableInputsState: false
          });

          this.refs.passwordData.hide();
        }
      });
  }

  saveMedicalInformation(noRedirect) {
    if (
      this.refs.paparado.value == "" &&
      this.state.health == "" &&
      this.state.colesterolTotal == "" &&
      this.state.colesterolLDL == "" &&
      this.state.colesterolHDL == "" &&
      this.state.trigliceridos == "" &&
      this.state.creatinina == "" &&
      this.state.glicemia == "" &&
      this.state.pabdominal == "" &&
      this.state.itbi == "" &&
      this.state.itbd == "" &&
      this.state.vop == "" &&
      this.state.presionParadoAlta == "" &&
      this.state.presionParadoBaja == "" &&
      this.state.presionSentadoAlta == "" &&
      this.state.presionSentadoBaja == "" &&
      this.state.frecuencia == "" &&
      this.state.temperatura == "" &&
      this.state.peso == "" &&
      this.state.altura == "" &&
      this.state.balanceNeuroIMuscular == "" &&
      this.state.balanceNeuroDMuscular == ""
    ) {
      this.refs.container.error(
        "Ingrese los datos solicitados para guardar el control médico",
        "No se guardaron los datos",
        {
          closeButton: true
        }
      );
    } else {
      let identificacion = this.props.params.patient;
      let balanceTot = 0;
      let balancen = Number(this.refs.balancen.value);
      let balancend = Number(this.refs.balancend.value);
      if (balancen > 0 && balancend > 0) {
        balanceTot = (balancen + balancend) / 2;
      } else if (balancend > 0) {
        balanceTot = balancend;
      } else {
        balanceTot = balancen;
      }

      let controlValue = this.state.all.length - 1;
      if (
        this.state.all.length === 0 ||
        this.state.all === undefined ||
        this.state.all === null
      ) {
        controlValue = 0;
      } else if (
        (this.state.all.length !== 0 ||
          this.state.all !== undefined ||
          this.state.all !== null) &&
        this.state.currentRol === "enfermero"
      ) {
        controlValue = "Precontrol";
      } else if (this.state.control === "Precontrol") {
        controlValue = this.state.all.length - 2;
      } else {
        controlValue = this.state.all.length - 1;
      }
      request
        .post("api/v1/medical/register")
        .set("Authorization", "Bearer " + getToken())
        .send({
          medical: {
            numeroDocumento: identificacion,
            presionParadoAlta: this.refs.paparado.value,
            presionParadoBaja: this.refs.paparado_n.value,
            presionSentadoAlta: this.refs.psentado.value,
            presionSentadoBaja: this.refs.psentado_n.value,
            frecuencia: this.refs.frecuencia.value,
            temperatura: this.refs.temperatura.value,
            peso: this.refs.peso.value,
            altura: this.refs.altura.value,
            balanceNeuroMuscularT: balanceTot,
            balanceNeuroMuscular:
              this.refs.balancen.value === "" ? 0 : this.refs.balancen.value,
            balanceNeuroMuscularD:
              this.refs.balancend.value === "" ? 0 : this.refs.balancend.value,
            tiempoCincoM: this.refs.meters.value,
            fuma: this.refs.smokegroup.props.selectedValue,
            satisfaccion: this.refs.satisfied.props.selectedValue,
            feliz: this.refs.happiness.props.selectedValue,
            preocupacion: this.refs.worried.props.selectedValue,
            depresion: this.refs.feeling.props.selectedValue,
            decaido: this.refs.dec.props.selectedValue,
            mets: this.refs.phy.props.selectedValue,
            movilidad: this.refs.mov.props.selectedValue,
            cuidadoPersonal: this.refs.cp.props.selectedValue,
            actividadesCotidianas: this.refs.actco.props.selectedValue,
            dolor: this.refs.dm.props.selectedValue,
            ansiedad: this.refs.ansdep.props.selectedValue,
            health: this.refs.health.value,
            colesterolTotal: this.refs.coltotal.value,
            colesterolLDL: this.refs.colldl.value,
            colesterolHDL: this.refs.colhdl.value,
            trigliceridos: this.refs.trigliceridos.value,
            creatinina: this.refs.creatinina.value,
            glicemia: this.refs.glicemia.value,
            perimetroAbdominal: this.refs.pabdominal.value,
            vop: this.refs.vop.value,
            itbIzquierdo: this.refs.itbi.value,
            itbDerecho: this.refs.itbd.value,
            observaciones: this.refs.observaciones.value,
            control: controlValue
          }
        })
        .set("Accept", "application/json")
        .end((err, res) => {
          if (err || !res.ok) {
            this.refs.container.error(
              "Algo inesperado paso y no se pudo guardar el control medico",
              "",
              {
                closeButton: true
              }
            );
          } else {
            this.refs.container.success(
              "Se guardaron los datos del control médico",
              "",
              {
                closeButton: true
              }
            );
            this.setState({
              medicalData: res.body
            });

            if (noRedirect) {
              if (this.state.patientDiabetico) {
                this.diabetesModal()
              }
              else {
                setTimeout(() => {
                  hashHistory.push("dashboard/" + identificacion);
                }, 2800);
              }
            } else {
              if (identificacion.length > 23) {
                setTimeout(() => {
                  hashHistory.push("dashboard/" + res.body.numeroDocumento);
                }, 2800);
              } else {
                setTimeout(() => {
                  hashHistory.push("dashboard/" + identificacion);
                }, 2800);
              }
            }
            if (this.state.control !== "Precontrol") {
              this.setState({ showAddControl: true });
            }
          }
        });
    }
  }

  oldFieldsData() { }

  updateMedicalInformation(noRedirect) {
    if (
      this.refs.paparado.value == "" &&
      this.state.health == "" &&
      this.state.colesterolTotal == "" &&
      this.state.colesterolLDL == "" &&
      this.state.colesterolHDL == "" &&
      this.state.trigliceridos == "" &&
      this.state.creatinina == "" &&
      this.state.glicemia == "" &&
      this.state.pabdominal == "" &&
      this.state.itbi == "" &&
      this.state.itbd == "" &&
      this.state.vop == "" &&
      this.state.presionParadoAlta == "" &&
      this.state.presionParadoBaja == "" &&
      this.state.presionSentadoAlta == "" &&
      this.state.presionSentadoBaja == "" &&
      this.state.frecuencia == "" &&
      this.state.temperatura == "" &&
      this.state.peso == "" &&
      this.state.altura == "" &&
      this.state.balanceNeuroIMuscular == "" &&
      this.state.balanceNeuroDMuscular == ""
    ) {
      this.refs.container.error(
        "Ingrese los datos solicitados para guardar el control médico",
        "No se guardaron los datos",
        {
          closeButton: true
        }
      );
    } else {
      let identificacion = this.props.params.patient;
      let balanceTot = 0;
      let balancen = Number(this.refs.balancen.value);
      let balancend = Number(this.refs.balancend.value);
      if (balancen > 0 && balancend > 0) {
        balanceTot = (balancen + balancend) / 2;
      } else if (balancend > 0) {
        balanceTot = balancend;
      } else {
        balanceTot = balancen;
      }

      let controlValue = "";
      if (
        this.state.control === "Precontrol" &&
        this.state.currentRol === "enfermero"
      ) {
        controlValue = this.state.control;
      } else if (
        this.state.control === "Precontrol" &&
        (this.state.currentRol === "admin" ||
          this.state.currentRol === "medico_sicor")
      ) {
        controlValue = this.state.all.length - 1;
        this.setState({ control: controlValue });
      }
      else {
        controlValue = this.state.control
      }
      controlValue = String(controlValue);
      request
        .put("api/v1/medical")
        .set("Authorization", "Bearer " + getToken())
        .send({
          _id: this.state.medicalData._id,
          id: this.state.medicalData.id,
          presionParadoAlta: this.refs.paparado.value,
          presionParadoBaja: this.refs.paparado_n.value,
          presionSentadoAlta: this.refs.psentado.value,
          presionSentadoBaja: this.refs.psentado_n.value,
          frecuencia: this.refs.frecuencia.value,
          temperatura: this.refs.temperatura.value,
          peso: this.refs.peso.value,
          altura: this.refs.altura.value,
          balanceNeuroMuscularT: balanceTot,
          balanceNeuroMuscular:
            this.refs.balancen.value === "" ? 0 : this.refs.balancen.value,
          balanceNeuroMuscularD:
            this.refs.balancend.value === "" ? 0 : this.refs.balancend.value,
          tiempoCincoM: this.refs.meters.value,
          fuma: this.refs.smokegroup.props.selectedValue,
          satisfaccion: this.refs.satisfied.props.selectedValue,
          feliz: this.refs.happiness.props.selectedValue,
          preocupacion: this.refs.worried.props.selectedValue,
          depresion: this.refs.feeling.props.selectedValue,
          decaido: this.refs.dec.props.selectedValue,
          mets: this.refs.phy.props.selectedValue,
          movilidad: this.refs.mov.props.selectedValue,
          cuidadoPersonal: this.refs.cp.props.selectedValue,
          actividadesCotidianas: this.refs.actco.props.selectedValue,
          dolor: this.refs.dm.props.selectedValue,
          ansiedad: this.refs.ansdep.props.selectedValue,
          health: this.refs.health.value,
          colesterolTotal: this.refs.coltotal.value,
          colesterolLDL: this.refs.colldl.value,
          colesterolHDL: this.refs.colhdl.value,
          trigliceridos: this.refs.trigliceridos.value,
          creatinina: this.refs.creatinina.value,
          glicemia: this.refs.glicemia.value,
          perimetroAbdominal: this.refs.pabdominal.value,
          vop: this.refs.vop.value,
          itbIzquierdo: this.refs.itbi.value,
          itbDerecho: this.refs.itbd.value,
          observaciones: this.refs.observaciones.value,
          timestamp: this.state.createdDate,
          patient: this.state.patient,
          control: controlValue
        })
        .set("Accept", "application/json")
        .end((err, res) => {
          if (err || !res.ok) {
            this.refs.container.error(
              "No se pudo actualizar el control medico actual.",
              "Intente de nuevo. revisando todos los campos del formulario.",
              {
                closeButton: true
              }
            );
            console.log(err);
          } else {
            this.refs.container.success(
              "Los datos del control medico fueron actualizados",
              "Datos médicos actualizados",
              {
                closeButton: true
              }
            );
            if (document.querySelector(".tab-control-selected span:nth-child(1)").innerHTML == "Precontrol") {
              document.querySelector(".tab-control-selected span:nth-child(1)").innerHTML = "Control " + controlValue
            }
            if (noRedirect) {
              if (this.state.patientDiabetico) {
                this.diabetesModal()
              }
              else {
                setTimeout(() => {
                  hashHistory.push("dashboard/" + identificacion);
                }, 2800);
              }
            } else {
              if (identificacion.length > 23) {
                setTimeout(() => {
                  hashHistory.push("dashboard/" + res.body.numeroDocumento);
                }, 2800);
              } else {
                setTimeout(() => {
                  hashHistory.push("dashboard/" + identificacion);
                }, 2800);
              }
            }
          }
        });
    }
  }

  /*findDiabetes () {
        let identificacion = this.props.params.patient
        console.log(1175)
        request
            .get('api/v1/diabetes/findDiabetesByIdOne/')
            .query({ id: identificacion })
            .set('Authorization', 'Bearer ' + getToken())
            .set('Accept', 'application/json')
            .end((err, res) => {
                if (err || !res.ok) {
                    // console.log('Error: ', err)
                } else {
                    let diabetesInfo = res.body
                    this.setState({
                        currentDiabetes: diabetesInfo,
                        duracionDm: diabetesInfo.duracionDm,
                        hba1c: diabetesInfo.hba1c,
                        _id: diabetesInfo._id ,
                        fevi: diabetesInfo.fevi,
                        fase: diabetesInfo.clasificacionFase,
                        funcional: diabetesInfo.claseFuncional,
                        pieDiabeValue: diabetesInfo.pieDiabeValue,
                        selectedAlb: this.riesgosBooleanToStr(diabetesInfo.albuminuria),
                        IAMValue: this.riesgosBooleanToStr(diabetesInfo.iamPrevDm),
                        ICCValue: this.riesgosBooleanToStr(diabetesInfo.iccPrev),
                        ACVValue: this.riesgosBooleanToStr(diabetesInfo.acvPrev),
                        AngPrev: this.riesgosBooleanToStr(diabetesInfo.anginaPre),
                        ojosValue: diabetesInfo.ojos, corazonValue: diabetesInfo.corazon,
                        rinonValue: diabetesInfo.rinon, neuroValue: diabetesInfo.neuropatia, cerebroValue: diabetesInfo.cerebroVascular,
                        vascularValue: diabetesInfo.vascularPeriferico, metabValue: diabetesInfo.metabolico
                    })
                }
            })

    }*/
  riesgosBooleanToStr(data) {
    if (data === true) {
      return "Si";
    } else {
      return "No";
    }
  }

  dashboardRedirect() {
    hashHistory.push("dashboard/" + this.props.params.patient);
  }

  processFunction(elem) {
    let elem_ = elem === undefined || elem === null ? "--" : elem;
    return elem_;
  }

  getStyle() {
    var profilePicture = this.state.patientImage
      ? this.state.patientImage
      : DefaultPicture;
    let styles = {
      img: {
        background: "url(" + profilePicture + ") center cover no-repeat"
      }
    };
    return Object.assign({}, styles.img);
  }

  loadMedicalControlTabs() {
    let identificacion = this.props.params.patient;
    request
      .get("api/v1/medical/findMedicalById")
      .query({ id: identificacion, limit: 10 })
      .set("Authorization", "Bearer " + getToken())
      .set("Accept", "application/json")
      .end((err, res) => {
        if (err || !res.ok) {
          console.log("Error: ", err);
        } else {
          let contador = res.body.length;
          let data = res.body;
          this.setState({ all: data });
        }
      });
  }

  cancelFunction(e) {
    e.preventDefault();
    if (this.state.dirty === true) {
      this.refs.container.warning(
        <span className="center-content">
          Tiene cambios pendientes ¿Desea regresar al Dashboard de todos modos?{" "}
          <br />
          <br />
          <span className="email-validation-container">
            <button
              type="button"
              className="btn btn-confirm clear"
              onClick={this.dashboardRedirect.bind(this)}
            >
              Si
            </button>
            <button type="button" className="btn btn-confirm clear">
              No
            </button>
          </span>
        </span>,
        <em>Tiene cambios pendientes</em>,
        {
          closeButton: true,
          showDuration: "300",
          hideDuration: "1000",
          timeOut: 0,
          extendedTimeOut: 0,
          showEasing: "swing",
          hideEasing: "linear",
          showMethod: "fadeIn",
          hideMethod: "fadeOut"
        }
      );
    } else {
      this.dashboardRedirect();
    }
  }
  showNewControl(e) {
    e.preventDefault();
    if (this.state.control === "Precontrol") {
      this.setState({ showAddControl: false });
    } else {
      this.setState({ showAddControl: true });
    }
  }
  getDiabetesByControl(control) {
    let state = this.state.diabetes.filter((item, id) => {
      try {
        if (item.control === control) {
          return item;
        }
      } catch (e) { }
    });
    return state;
  }

  vlookup(index, table) {
    for (var i = 0, l = table[0].length; i < l; i++) {
      if (index === table[0][i]) return table[1][i];
      if (i < l - 1) {
        if (index > table[0][i] && index < table[0][i + 1]) return table[1][i];
      }
      if (i === l) return table[1][l];
    }
  }

  tabControl(e) {
    e.preventDefault();
    if (this.state.control === "Precontrol") {
      this.setState({ showAddControl: false });
    }
    if (e.target.className === "plus" || e.target.className == "add-control") {
      return false;
      return;
    }
    if (e.target.className == "add-control" && this.state.all.length > 0) {
      return false;
    }

    let size = this.state.all.length;
    var scope;
    let state = this.state.all.filter((item, id) => {
      if (item._id === e.target.id) {
        scope = id;
        return item;
      } else {
        return;
      }
    });
    var newDiabetes = this.getDiabetesByControl(String(scope))[0];
    if (newDiabetes == undefined) {
      this.setState({ classNameDiabetes: "hidden" });
      if (this.state.diabetes !== undefined && this.state.diabetes !== null)
        newDiabetes = this.state.diabetes[this.state.diabetes.length - 1];
    } else {
      this.setState({ classNameDiabetes: "visible" });
    }

    let readMode =
      scope + 1 === size ? "medical-content hide" : "medical-content";
    let editionMode =
      scope + 1 === size ? "medical-content" : "medical-content hide";
    const processFunction = elem => {
      let elem_ = (elem === undefined) | (elem === null) ? "--" : elem;
      return elem_;
    };
    const imc = () => {
      return Math.floor(state[0].peso / Math.pow(state[0].altura / 100, 2));
    };

    try {
      let creadoPor = "";
      let modificadoPor = "";
      console.log(state[0].modificadoPor);
      try {
        modificadoPor = modificadoPor ? modificadoPor : state[0].modificadoPor;
        creadoPor = creadoPor ? creadoPor : state[0].modificadoPor;
        creadoPor = processFunction(state[0].createdBy.nombrecompleto);
        modificadoPor = processFunction(state[0].modifiedBy.nombrecompleto);
      } catch (e) {
        console.log(e);
      }
      this.setState({
        medicalData: state[0],
        presionParadoAlta: processFunction(state[0].presionParadoAlta),
        presionParadoBaja: processFunction(state[0].presionParadoBaja),
        presionSentadoAlta: processFunction(state[0].presionSentadoAlta),
        presionSentadoBaja: processFunction(state[0].presionSentadoBaja),
        frecuencia: processFunction(state[0].frecuencia),
        peso: processFunction(state[0].peso),
        altura: processFunction(state[0].altura),
        imc: imc(),
        duracionDm: processFunction(state[0].duracionDm),
        pabdominal: processFunction(state[0].perimetroAbdominal),
        balanceNeuroIMuscular: processFunction(state[0].balanceNeuroMuscular),
        balanceNeuroDMuscular: processFunction(state[0].balanceNeuroMuscularD),
        itbi: processFunction(state[0].itbIzquierdo),
        itbd: processFunction(state[0].itbDerecho),
        vop: processFunction(state[0].vop),
        fuma: processFunction(state[0].fuma),
        tiempoCincoM: processFunction(state[0].tiempoCincoM),
        temperatura: processFunction(state[0].temperatura),
        satisfaccion: processFunction(state[0].satisfaccion),
        depresion: processFunction(state[0].depresion),
        feliz: processFunction(state[0].feliz),
        preocupacion: processFunction(state[0].preocupacion),
        decaido: processFunction(state[0].decaido),
        movilidad: processFunction(state[0].movilidad),
        cuidadoPersonal: processFunction(state[0].cuidadoPersonal),
        actividadesCotidianas: processFunction(state[0].actividadesCotidianas),
        dolor: processFunction(state[0].dolor),
        ansiedad: processFunction(state[0].ansiedad),
        mets: processFunction(state[0].mets),
        health: processFunction(state[0].health),
        colesterolTotal: processFunction(state[0].colesterolTotal),
        colesterolLDL: processFunction(state[0].colesterolLDL),
        colesterolHDL: processFunction(state[0].colesterolHDL),
        creatinina: processFunction(state[0].creatinina),
        glicemia: processFunction(state[0].glicemia),
        trigliceridos: processFunction(state[0].trigliceridos),
        creadoPor: processFunction(creadoPor),
        modificadoPor: processFunction(modificadoPor),
        notasText: processFunction(state[0].observaciones),
        readMode: readMode,
        editionMode: editionMode,
        scope: scope
      });
      this.setState({
        duracionDm: newDiabetes.duracionDm,
        hba1c: newDiabetes.hba1c,
        _id: newDiabetes._id,
        // fevi: newDiabetes.fevi,
        // control: newDiabetes.control,
        // fase: newDiabetes.clasificacionFase,
        // funcional: newDiabetes.claseFuncional,
        // pieDiabeValue: newDiabetes.pieDiabeValue,
        selectedAlb: this.riesgosBooleanToStr(newDiabetes.albuminuria),
        IAMValue: this.riesgosBooleanToStr(newDiabetes.iamPrevDm),
        ICCValue: this.riesgosBooleanToStr(newDiabetes.iccPrev),
        ACVValue: this.riesgosBooleanToStr(newDiabetes.acvPrev),
        AngPrev: this.riesgosBooleanToStr(newDiabetes.anginaPre),
        ojosValue: newDiabetes.ojos,
        corazonValue: newDiabetes.corazon,
        rinonValue: newDiabetes.rinon,
        neuroValue: newDiabetes.neuropatia,
        cerebroValue: newDiabetes.cerebroVascular,
        vascularValue: newDiabetes.vascularPeriferico,
        metabValue: newDiabetes.metabolico
      });
    } catch (e) { }

    var lengthElements = document.getElementsByClassName("tab-control");
    var i = 0;
    for (i = 0; i < lengthElements.length; i++) {
      lengthElements[i].className = "tab-control";
    }
    if (e.target.className === "tab-control") {
      e.target.className = "tab-control tab-control-selected";
    }
    if (e.target.className === "date") {
      e.target.parentNode.className = "tab-control tab-control-selected";
    }

    var balancePerAge = [
      [18, 40, 50, 60, 70, 80, 90, 100],
      [45, 42, 42, 32, 22, 10, 10, 10]
    ];
    var balanceExpected = this.vlookup(this.state.patientAge, balancePerAge);

    if (imc() >= 20 && imc() < 25) {
      this.setState({ IMCRange: "good-range-text" });
    } else if (imc() >= 25 && imc() < 30) {
      this.setState({ IMCRange: "regular-range-text" });
    } else if (imc() < 20 || imc() >= 30) {
      this.setState({ IMCRange: "bad-range-text" });
    }

    if (
      this.state.patientGender === "m" &&
      Number(state[0].perimetroAbdominal) <= 94
    ) {
      this.setState({ perAbdRange: "good-range-text" });
    } else if (
      this.state.patientGender === "m" &&
      Number(state[0].perimetroAbdominal) > 94
    ) {
      this.setState({ perAbdRange: "bad-range-text" });
    }

    if (
      this.state.patientGender === "f" &&
      Number(state[0].perimetroAbdominal) <= 82
    ) {
      this.setState({ perAbdRange: "good-range-text" });
    } else if (
      this.state.patientGender === "f" &&
      Number(state[0].perimetroAbdominal) > 82
    ) {
      this.setState({ perAbdRange: "bad-range-text" });
    }

    if (state[0].itbIzquierdo < 0.9 || state[0].itbIzquierdo > 1.2) {
      this.setState({ itbiRange: "bad-range-text" });
    } else if (state[0].itbIzquierdo >= 0.9 || state[0].itbIzquierdo <= 1.2) {
      this.setState({ itbiRange: "good-range-text" });
    }

    if (state[0].itbDerecho < 0.9 || state[0].itbDerecho > 1.2) {
      this.setState({ itbdRange: "bad-range-text" });
    } else if (state[0].itbDerecho >= 0.9 || state[0].itbDerecho <= 1.2) {
      this.setState({ itbdRange: "good-range-text" });
    }

    if (state[0].vop < 10) {
      this.setState({ vopRange: "good-range-text" });
    } else if (state[0].vop >= 10) {
      this.setState({ vopRange: "bad-range-text" });
    }

    if (Number(state[0].frecuencia) < 50 || Number(state[0].frecuencia) >= 90) {
      this.setState({ fcRange: "bad-range-text" });
    } else if (
      Number(state[0].frecuencia) >= 50 &&
      Number(state[0].frecuencia) < 90
    ) {
      this.setState({ fcRange: "good-range-text" });
    }

    if (
      Number(state[0].tiempoCincoM) < 50 ||
      Number(state[0].tiempoCincoM) >= 90
    ) {
      this.setState({ tiempo: "bad-range-text" });
    } else if (
      Number(state[0].tiempoCincoM) >= 50 &&
      Number(state[0].tiempoCincoM) < 90
    ) {
      this.setState({ tiempo: "good-range-text" });
    }

    if (
      Number(state[0].presionParadoAlta) < 120 &&
      Number(state[0].presionParadoBaja) < 80
    ) {
      this.setState({ presPRange: "good-range-text" });
    } else if (
      (Number(state[0].presionParadoAlta) >= 120 &&
        Number(state[0].presionParadoAlta) <= 139) ||
      (Number(state[0].presionParadoBaja) >= 80 &&
        Number(state[0].presionParadoBaja) <= 89)
    ) {
      this.setState({ presPRange: "regular-range-text" });
    } else if (
      Number(state[0].presionParadoAlta) > 140 &&
      Number(state[0].presionParadoBaja) >= 90
    ) {
      this.setState({ presPRange: "bad-range-text" });
    }

    var sistolica =
      (parseInt(this.state.presionParadoAlta) +
        parseInt(this.state.presionSentadoAlta)) /
      2;
    if (Number(sistolica) < 120) {
      this.setState({ sistolicaRange: "good-range-text" });
    } else if (Number(sistolica) >= 120 && Number(sistolica) <= 139) {
      this.setState({ sistolicaRange: "regular-range-text" });
    } else if (Number(sistolica) >= 140) {
      this.setState({ sistolicaRange: "bad-range-text" });
    }

    if (
      Number(state[0].presionSentadoAlta) < 120 &&
      Number(state[0].presionSentadoBaja) < 80
    ) {
      this.setState({ presSRange: "good-range-text" });
    } else if (
      (Number(state[0].presionSentadoAlta) >= 120 &&
        Number(state[0].presionSentadoAlta) <= 139) ||
      (Number(state[0].presionSentadoBaja) >= 80 &&
        Number(state[0].presionSentadoBaja) <= 89)
    ) {
      this.setState({ presSRange: "regular-range-text" });
    } else if (
      Number(state[0].presionSentadoAlta) >= 140 &&
      Number(state[0].presionSentadoBaja) >= 90
    ) {
      this.setState({ presSRange: "bad-range-text" });
    }

    if (state[0].fuma === "No") {
      this.setState({ tabaqRange: "good-range-text" });
    } else if (state[0].fuma === "Si") {
      this.setState({ tabaqRange: "bad-range-text" });
    }

    if (state[0].balanceNeuroMuscular < balanceExpected) {
      this.setState({ balIzRange: "bad-range-text" });
    } else if (state[0].balanceNeuroMuscular >= balanceExpected) {
      this.setState({ balIzRange: "good-range-text" });
    }

    if (state[0].balanceNeuroMuscularD < balanceExpected) {
      this.setState({ balDeRange: "bad-range-text" });
    } else if (state[0].balanceNeuroMuscularD >= balanceExpected) {
      this.setState({ balDeRange: "good-range-text" });
    }

    if (state[0].colesterolTotal < 200) {
      this.setState({ coltRange: "good-range-text" });
    } else if (
      state[0].colesterolTotal >= 200 &&
      state[0].colesterolTotal <= 270
    ) {
      this.setState({ coltRange: "regular-range-text" });
    } else if (state[0].colesterolTotal > 270) {
      this.setState({ coltRange: "bad-range-text" });
    }

    if (state[0].trigliceridos < 150) {
      this.setState({ trigRange: "good-range-text" });
    } else if (state[0].trigliceridos >= 150 && state[0].trigliceridos <= 300) {
      this.setState({ trigRange: "regular-range-text" });
    } else if (state[0].trigliceridos > 300) {
      this.setState({ trigRange: "bad-range-text" });
    }

    if (state[0].colesterolLDL < 100) {
      this.setState({ collRange: "good-range-text" });
    } else if (state[0].colesterolLDL >= 100 && state[0].colesterolLDL <= 190) {
      this.setState({ collRange: "regular-range-text" });
    } else if (state[0].colesterolLDL > 190) {
      this.setState({ collRange: "bad-range-text" });
    }

    if (state[0].colesterolHDL < 40) {
      this.setState({ colhRange: "bad-range-text" });
    } else if (state[0].colesterolHDL >= 40 && state[0].colesterolHDL <= 60) {
      this.setState({ colhRange: "regular-range-text" });
    } else if (state[0].colesterolHDL > 60) {
      this.setState({ colhRange: "good-range-text" });
    }

    if (state[0].creatinina < 1.2) {
      this.setState({ creatRange: "good-range-text" });
    } else if (state[0].creatinina >= 1.2 && state[0].creatinina <= 1.5) {
      this.setState({ creatRange: "regular-range-text" });
    } else if (state[0].creatinina > 1.5) {
      this.setState({ creatRange: "bad-range-text" });
    }

    if (state[0].movilidad === 1) {
      this.setState({ movRange: "color-one-text" });
    } else if (state[0].movilidad === 2) {
      this.setState({ movRange: "color-two-text" });
    } else if (state[0].movilidad === 3) {
      this.setState({ movRange: "color-three-text" });
    }

    if (state[0].dolor === 1) {
      this.setState({ dolRange: "color-one-text" });
    } else if (state[0].dolor === 2) {
      this.setState({ dolRange: "color-two-text" });
    } else if (state[0].dolor === 3) {
      this.setState({ dolRange: "color-three-text" });
    }

    if (state[0].cuidadoPersonal === 1) {
      this.setState({ cuiRange: "color-one-text" });
    } else if (state[0].cuidadoPersonal === 2) {
      this.setState({ cuiRange: "color-two-text" });
    } else if (state[0].cuidadoPersonal === 3) {
      this.setState({ cuiRange: "color-three-text" });
    }

    if (state[0].actividadesCotidianas === 1) {
      this.setState({ actRange: "color-one-text" });
    } else if (state[0].actividadesCotidianas === 2) {
      this.setState({ actRange: "color-two-text" });
    } else if (state[0].actividadesCotidianas === 3) {
      this.setState({ actRange: "color-three-text" });
    }

    if (state[0].ansiedad === 1) {
      this.setState({ ansRange: "color-one-text" });
    } else if (state[0].ansiedad === 2) {
      this.setState({ ansRange: "color-two-text" });
    } else if (state[0].ansiedad === 3) {
      this.setState({ ansRange: "color-three-text" });
    }

    if (state[0].mets === 1) {
      this.setState({ metsRange: "color-three-text" });
    } else if (state[0].mets === 2) {
      this.setState({ metsRange: "color-two-text" });
    } else if (state[0].mets === 3) {
      this.setState({ metsRange: "color-five-text" });
    } else if (state[0].mets === 4) {
      this.setState({ metsRange: "color-four-text" });
    } else if (state[0].mets === 5) {
      this.setState({ metsRange: "color-one-text" });
    }

    if (state[0].preocupacion === 1) {
      this.setState({ preRange: "color-one-text" });
    } else if (state[0].preocupacion === 2) {
      this.setState({ preRange: "color-four-text" });
    } else if (state[0].preocupacion === 3) {
      this.setState({ preRange: "color-five-text" });
    } else if (state[0].preocupacion === 4) {
      this.setState({ preRange: "color-two-text" });
    } else if (state[0].preocupacion === 5) {
      this.setState({ preRange: "color-six-text" });
    } else if (state[0].preocupacion === 6) {
      this.setState({ preRange: "color-seven-text" });
    } else if (state[0].preocupacion === 7) {
      this.setState({ preRange: "color-eight-text" });
    } else if (state[0].preocupacion === 8) {
      this.setState({ preRange: "color-nine-text" });
    } else if (state[0].preocupacion === 9) {
      this.setState({ preRange: "color-ten-text" });
    } else if (state[0].preocupacion === 10) {
      this.setState({ preRange: "color-three-text" });
    }

    if (state[0].decaido === 1) {
      this.setState({ decRange: "color-one-text" });
    } else if (state[0].decaido === 2) {
      this.setState({ decRange: "color-four-text" });
    } else if (state[0].decaido === 3) {
      this.setState({ decRange: "color-five-text" });
    } else if (state[0].decaido === 4) {
      this.setState({ decRange: "color-two-text" });
    } else if (state[0].decaido === 5) {
      this.setState({ decRange: "color-six-text" });
    } else if (state[0].decaido === 6) {
      this.setState({ decRange: "color-seven-text" });
    } else if (state[0].decaido === 7) {
      this.setState({ decRange: "color-eight-text" });
    } else if (state[0].decaido === 8) {
      this.setState({ decRange: "color-nine-text" });
    } else if (state[0].decaido === 9) {
      this.setState({ decRange: "color-ten-text" });
    } else if (state[0].decaido === 10) {
      this.setState({ decRange: "color-three-text" });
    }

    if (state[0].depresion === 10) {
      this.setState({ conRange: "color-one-text" });
    } else if (state[0].depresion === 9) {
      this.setState({ conRange: "color-four-text" });
    } else if (state[0].depresion === 8) {
      this.setState({ conRange: "color-five-text" });
    } else if (state[0].depresion === 7) {
      this.setState({ conRange: "color-two-text" });
    } else if (state[0].depresion === 6) {
      this.setState({ conRange: "color-six-text" });
    } else if (state[0].depresion === 5) {
      this.setState({ conRange: "color-seven-text" });
    } else if (state[0].depresion === 4) {
      this.setState({ conRange: "color-eight-text" });
    } else if (state[0].depresion === 3) {
      this.setState({ conRange: "color-nine-text" });
    } else if (state[0].depresion === 2) {
      this.setState({ conRange: "color-ten-text" });
    } else if (state[0].depresion === 1) {
      this.setState({ conRange: "color-three-text" });
    }

    if (state[0].satisfaccion === 10) {
      this.setState({ satRange: "color-one-text" });
    } else if (state[0].satisfaccion === 9) {
      this.setState({ satRange: "color-four-text" });
    } else if (state[0].satisfaccion === 8) {
      this.setState({ satRange: "color-five-text" });
    } else if (state[0].satisfaccion === 7) {
      this.setState({ satRange: "color-two-text" });
    } else if (state[0].satisfaccion === 6) {
      this.setState({ satRange: "color-six-text" });
    } else if (state[0].satisfaccion === 5) {
      this.setState({ satRange: "color-seven-text" });
    } else if (state[0].satisfaccion === 4) {
      this.setState({ satRange: "color-eight-text" });
    } else if (state[0].satisfaccion === 3) {
      this.setState({ satRange: "color-nine-text" });
    } else if (state[0].satisfaccion === 2) {
      this.setState({ satRange: "color-ten-text" });
    } else if (state[0].satisfaccion === 1) {
      this.setState({ satRange: "color-three-text" });
    }

    if (state[0].feliz === 10) {
      this.setState({ felRange: "color-one-text" });
    } else if (state[0].feliz === 9) {
      this.setState({ felRange: "color-four-text" });
    } else if (state[0].feliz === 8) {
      this.setState({ felRange: "color-five-text" });
    } else if (state[0].feliz === 7) {
      this.setState({ felRange: "color-two-text" });
    } else if (state[0].feliz === 6) {
      this.setState({ felRange: "color-six-text" });
    } else if (state[0].feliz === 5) {
      this.setState({ felRange: "color-seven-text" });
    } else if (state[0].feliz === 4) {
      this.setState({ felRange: "color-eight-text" });
    } else if (state[0].feliz === 3) {
      this.setState({ felRange: "color-nine-text" });
    } else if (state[0].feliz === 2) {
      this.setState({ felRange: "color-ten-text" });
    } else if (state[0].feliz === 1) {
      this.setState({ felRange: "color-three-text" });
    }

    if (this.state.selectedAlb === "Si") {
      this.setState({ albuRange: "bad-range-text" });
    } else if (this.state.selectedAlb === "No") {
      this.setState({ albuRange: "good-range-text" });
    }

    if (this.state.funcional === "I") {
      this.setState({ clasFRange: "good-range-text" });
    } else if (this.state.funcional === "II") {
      this.setState({ clasFRange: "regular-range-text" });
    } else if (
      this.state.funcional === "III" ||
      this.state.funcional === "IV"
    ) {
      this.setState({ clasFRange: "bad-range-text" });
    }

    if (this.state.fase === "1") {
      this.setState({ clasSRange: "good-range-text" });
    } else if (this.state.fase === "3B") {
      this.setState({ clasSRange: "regular-range-text" });
    } else if (this.state.fase === "2" || this.state.fase === "3A") {
      this.setState({ clasSRange: "bad-range-text" });
    }

    if (this.state.fevi < 30) {
      this.setState({ feviVRange: "bad-range-text" });
    } else if (this.state.fevi >= 30 && this.state.fevi < 40) {
      this.setState({ feviVRange: "orange-range-text" });
    } else if (this.state.fevi >= 40 && this.state.fevi <= 50) {
      this.setState({ feviVRange: "regular-range-text" });
    } else if (this.state.fevi > 50) {
      this.setState({ feviVRange: "good-range-text" });
    }

    if (this.state.pieDiabeValue === "No") {
      this.setState({ evaPDRange: "good-range-text" });
    } else {
      this.setState({ evaPDRange: "bad-range-text" });
    }

    if (this.state.duracionDm < 10) {
      this.setState({ duraDRange: "good-range-text" });
    } else if (this.state.duracionDm > 20) {
      this.setState({ duraDRange: "bad-range-text" });
    } else {
      this.setState({ duraDRange: "orange-range-text" });
    }

    if (this.state.hba1c < 5.5) {
      this.setState({ hba1cRange: "good-range-text" });
    } else if (this.state.hba1c >= 5.5 && this.state.hba1c < 6.5) {
      this.setState({ hba1cRange: "regular-range-text" });
    } else if (this.state.hba1c >= 6.5 && this.state.hba1c <= 8.5) {
      this.setState({ hba1cRange: "orange-range-text" });
    } else if (this.state.hba1c > 8.5) {
      this.setState({ hba1cRange: "bad-range-text" });
    }

    if (this.state.IAMValue === "No") {
      this.setState({ iamRange: "good-range-text" });
    } else {
      this.setState({ iamRange: "bad-range-text" });
    }

    if (this.state.ICCValue === "No") {
      this.setState({ iccRange: "good-range-text" });
    } else {
      this.setState({ iccRange: "bad-range-text" });
    }

    if (this.state.ACVValue === "No") {
      this.setState({ acvRange: "good-range-text" });
    } else {
      this.setState({ acvRange: "bad-range-text" });
    }

    if (this.state.AngPrev === "No") {
      this.setState({ angRange: "good-range-text" });
    } else {
      this.setState({ angRange: "bad-range-text" });
    }
  }
  exportCsv() {
    this.refs.container.success("Espera se esta generando csv...", "", {
      timeOut: 800,
      closeButton: true
    });
    var url2 = "api/v1/medical/exportByNumberDocument";
    let identificacion = this.props.params.patient;
    request
      .get(url2)
      .query({ numeroDocumento: identificacion })
      .set("Authorization", "Bearer " + getToken())
      .set("Accept", "text/csv")
      .end((err, res) => {
        if (res) {
          var uri =
            "data:text/csv;charset=utf-8," + encodeURIComponent(res.text);
          window.open(uri, "pacientes.csv");
          this.refs.container.success("El documento csv se descargo", "", {
            timeOut: 4000,
            closeButton: true
          });
        } else if (err) {
          err;
        }
      });
  }
  addControll(e) {
    e.preventDefault();
    // this.setState({ showAddControl: false, _id: '', newControl: true })
    if (
      (e.target.className === "add-control" && this.state.all.length > 0) ||
      (e.target.className === "plus" && this.state.all.length > 0)
    ) {
      let objs = this.state.all;
      let size = this.state.all.length - 1;
      let last = objs[size];
      let difftime = moment().diff(
        moment(last.timestamp, "x").format(),
        "days"
      );
      if (difftime < 30 && difftime >= 0) {
        this.setState({ showModal: true });
      } else {
        console.log("now", moment().format("HH:mm:ss"));
        this.setState({ showModal: false });
        this.addControll_();
      }
    }
  }
  addControll_() {
    this.setState({ showAddControl: false, _id: "", newControl: true });
    let objs = this.state.all;
    let size = this.state.all.length - 1;
    let last = objs[size];
    function clone(obj) {
      if (null == obj || "object" != typeof obj) return obj;
      var copy = obj.constructor();
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
      }
      return copy;
    }
    let newobj = clone(last);

    objs.push(newobj);
    let objDiab = this.state.diabetes;
    let lastDiab = this.getDiabetesByControl(newobj.control)[0];
    let newobjDiab = clone(lastDiab);
    objDiab.push(newobjDiab);
    delete newobj._id;
    newobj._id = String(Math.floor(Math.random() * 10000));
    newobj.timestamp = moment().format("x");
    let n = size + 1;
    newobj.control = String(n);
    this.lockEdition(newobj.timestamp);
    let diabetesObjs = this.state.diabetes;
    this.findDiabetes();
    let newDiabetes = clone(this.state.currentDiabetes);
    newDiabetes.control = String(n);
    newDiabetes._id = String(Math.floor(Math.random() * 10000));

    let readMode = "medical-content hide";
    let editionMode = "medical-content";
    try {
      var arr = this.mesesFinish(this.state.meses);
    } catch (e) { }

    this.setState({
      all: objs,
      arr: arr,
      control: size,
      diabetes: objDiab,
      medicalData: newobj,
      control: newobj.control,
      currentDiabetes: newDiabetes,
      readMode: readMode,
      editionMode: editionMode,
      duracionDm: newDiabetes.duracionDm,
      hba1c: newDiabetes.hba1c,
      _id: newDiabetes._id,
      fevi: newDiabetes.fevi,
      control: newDiabetes.control,
      fase: newDiabetes.clasificacionFase,
      funcional: newDiabetes.claseFuncional,
      pieDiabeValue: newDiabetes.pieDiabeValue,
      selectedAlb: this.riesgosBooleanToStr(newDiabetes.albuminuria),
      IAMValue: this.riesgosBooleanToStr(newDiabetes.iamPrevDm),
      ICCValue: this.riesgosBooleanToStr(newDiabetes.iccPrev),
      ACVValue: this.riesgosBooleanToStr(newDiabetes.acvPrev),
      AngPrev: this.riesgosBooleanToStr(newDiabetes.anginaPre),
      ojosValue: newDiabetes.ojos,
      corazonValue: newDiabetes.corazon,
      rinonValue: newDiabetes.rinon,
      neuroValue: newDiabetes.neuropatia,
      cerebroValue: newDiabetes.cerebroVascular,
      vascularValue: newDiabetes.vascularPeriferico,
      metabValue: newDiabetes.metabolico
    });
    this.findCore2Data();
  }
  diabetesModal(e) {
    console.log("diabetesModal");
    this.findDiabetes();
    this.setState({ modal: true, overlymain: "overly-main" });
  }
  closeModal(e) {
    this.setState({ modal: false, overlymain: "hide" });
  }
  // diabetes controller

  pieDiabeticoV(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ pieDiabeValue: changeEvent.target.value });
    } else {
      this.setState({ pieDiabeValue: changeEvent.target.value });
    }
  }

  controlChange() {
    this.setState({ control: this.refs.control.value });
  }

  feviChange() {
    this.setState({ fevi: this.refs.fevi.value });
  }

  faseChange() {
    this.setState({ fase: this.refs.fase.value });
  }

  funcionalChange() {
    this.setState({ funcional: this.refs.funcional.value });
  }

  IAMDM(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ IAMValue: changeEvent.target.value });
    } else {
      this.setState({ IAMValue: changeEvent.target.value });
    }
  }

  ICCDM(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ ICCValue: changeEvent.target.value });
    } else {
      this.setState({ ICCValue: changeEvent.target.value });
    }
  }

  ACVVAL(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ ACVValue: changeEvent.target.value });
    } else {
      this.setState({ ACVValue: changeEvent.target.value });
    }
  }

  ANGPRE(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ AngPrev: changeEvent.target.value });
    } else {
      this.setState({ AngPrev: changeEvent.target.value });
    }
  }

  albuminuria(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ selectedAlb: changeEvent.target.value });
    } else {
      this.setState({ selectedAlb: changeEvent.target.value });
    }
  }

  pieDiabeticoV(changeEvent) {
    if (changeEvent.target.value === "Si") {
      this.setState({ pieDiabeValue: changeEvent.target.value });
    } else {
      this.setState({ pieDiabeValue: changeEvent.target.value });
    }
  }

  feviChange() {
    this.setState({ fevi: this.refs.fevi.value });
  }

  faseChange() {
    this.setState({ fase: this.refs.fase.value });
  }

  funcionalChange() {
    this.setState({ funcional: this.refs.funcional.value });
  }

  ojosHandleChange(e) {
    this.setState({ ojosValue: e.target.value });
  }

  rinonHandleChange(e) {
    this.setState({ rinonValue: e.target.value });
  }

  corazonHandleChange(e) {
    this.setState({ corazonValue: e.target.value });
  }

  nueroHandleChange(e) {
    this.setState({ neuroValue: e.target.value });
  }

  cerebroHandleChange(e) {
    this.setState({ cerebroValue: e.target.value });
  }

  vascularHandleChange(e) {
    this.setState({ vascularValue: e.target.value });
  }
  metabHandleChange(e) {
    console.log(e.target.value);
    this.setState({ metabValue: e.target.value });
  }

  hba1cHandleChange() {
    this.setState({ hba1c: this.refs.HbA1c.value });
    var inputdataType = new RegExp(/^[+-]?\d+(\.\d+)?$/, "g");

    if (
      Number(this.refs.HbA1c.value) > 15 ||
      Number(this.refs.HbA1c.value) < 5
    ) {
      this.setState({
        textH: "Ingrese un valor entre 5 y 15",
        hba1cClass: "severity-input severity-input-error"
      });
    } else if (inputdataType.test(this.refs.HbA1c.value) === false) {
      this.setState({
        textH: "Ingrese un valor numérico",
        hba1cClass: "severity-input severity-input-error"
      });
    } else {
      this.setState({ textH: "", hba1cClass: "severity-input" });
    }
  }

  extremeAlert() {
    this.saveDiabetes();
    this.refs.container.error(
      "Por favor remite el paciente a observación ya que el valor ingresado indica que la salud de paciente no es buena",
      "¡El estado de salud del paciente no es bueno!",
      {
        closeButton: true
      }
    );
  }

  duracionDmChange() {
    this.setState({ duracionDm: this.refs.time.value });
    var currentYear = new Date().getFullYear();
    var inputdataType = new RegExp("^\\d{1,2}$");
    if (
      Number(this.refs.time.value) > this.state.patientAge ||
      Number(this.refs.time.value) < 0
    ) {
      this.setState({
        textTime:
          "La duración de la diabetes no puede ser mayor a la edad del paciente",
        timeClass: "severity-input severity-input-error"
      });
    } else if (inputdataType.test(this.refs.time.value) === false) {
      this.setState({
        textTime: "Ingrese un número entre 0 y " + this.state.patientAge,
        timeClass: "severity-input severity-input-error"
      });
    } else {
      this.setState({ textTime: "", timeClass: "severity-input" });
    }
  }
  clickBack(e) {
    var url = "/#/tabledata/" + this.props.params.patient;
    window.location.href = url;
    console.log("e");
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }
  handleContinueModal() {
    this.setState({ showModal: false });
    this.addControll_();
  }
  saveDiabetes() {
    const saveFunctionDiab = () => {
      let identificacion = this.props.params.patient;
      let iam = this.state.IAMValue === "Si";
      let icc = this.state.ICCValue === "Si";
      let acv = this.state.ACVValue === "Si";
      let ang = this.state.AngPrev === "Si";
      let alb = this.state.selectedAlb === "Si";
      let control = this.state.control;
      let ojosValue = parseInt(this.state.ojosValue)
        ? parseInt(this.state.ojosValue)
        : "0";
      let rinonValue = parseInt(this.state.rinonValue)
        ? parseInt(this.state.rinonValue)
        : "0";
      let neuroValue = parseInt(this.state.neuroValue)
        ? parseInt(this.state.neuroValue)
        : "0";
      let cerebroValue = parseInt(this.state.cerebroValue)
        ? parseInt(this.state.cerebroValue)
        : "0";
      let corazonValue = parseInt(this.state.corazonValue)
        ? parseInt(this.state.corazonValue)
        : "0";
      let vascularValue = parseInt(this.state.vascularValue)
        ? parseInt(this.state.vascularValue)
        : "0";
      let metabValue = parseInt(this.state.metabValue)
        ? parseInt(this.state.metabValue)
        : "0";

      request
        .post("api/v1/diabetes/register")
        .set("Authorization", "Bearer " + getToken())
        .send({
          diabetes: {
            numeroDocumento: identificacion,
            duracionDm: parseInt(this.state.duracionDm),
            presSistolica: this.state.presSistolica,
            hba1c: this.state.hba1c,
            albuminuria: alb,
            iamPrevDm: iam,
            iccPrev: icc,
            acvPrev: acv,
            anginaPre: ang,
            fevi: this.state.fevi,
            pieDiabeValue: this.state.pieDiabeValue,
            claseFuncional: this.state.funcional,
            clasificacionFase: this.state.fase,
            ojos: parseInt(ojosValue),
            rinon: parseInt(rinonValue),
            neuropatia: parseInt(neuroValue),
            control: control ? control : "0",
            cerebroVascular: parseInt(cerebroValue),
            corazon: parseInt(corazonValue),
            vascularPeriferico: parseInt(vascularValue),
            metabolico: parseInt(metabValue)
          }
        })
        .set("Accept", "application/json")
        .end((err, res) => {
          if (err || !res.ok) {
            this.refs.container.error(
              "Algo inesperado paso y no se pudo guardar los datos de diabetes",
              "",
              {
                closeButton: true
              }
            );
          } else {
            this.refs.container.success(
              "Los datos de diabetes se guardaron correctamente",
              "Se genero un nuevo control de diabetes.",
              {
                closeButton: true
              }
            );
            this.setState({ modal: false, overlymain: "hide" });
          }
        });
    };
    // end post
    var inputdataType = new RegExp("^\\d{1,2}$");
    if (this.refs.HbA1c.value === "" || this.refs.time.value === "") {
      this.duracionDmChange();
      this.hba1cHandleChange();
    } else if (
      Number(this.refs.time.value) > this.state.patientAge ||
      Number(this.refs.time.value) < 0
    ) {
      this.setState({
        textTime:
          "La duración de la diabetes no puede ser mayor a la edad del paciente",
        timeClass: "severity-input severity-input-error"
      });
    } else if (inputdataType.test(this.refs.HbA1c.value) === false) {
      this.setState({
        textH: "Ingrese un valor entre 5 y 15",
        hba1cClass: "severity-input severity-input-error"
      });
    }
    if (
      Number(this.refs.time.value) > this.state.patientAge ||
      Number(this.refs.time.value) < 0
    ) {
      this.setState({
        textTime: "Ingrese un número entre 0 y " + this.state.patientAge,
        timeClass: "severity-input severity-input-error"
      });
    } else if (inputdataType.test(this.refs.time.value) === false) {
      this.setState({
        textTime: "Ingrese un número entre 0 y " + this.state.patientAge,
        timeClass: "severity-input severity-input-error"
      });
    } else {
      let identificacion = this.props.params.patient;
      let iam = this.state.IAMValue === "Si";
      let icc = this.state.ICCValue === "Si";
      let acv = this.state.ACVValue === "Si";
      let ang = this.state.AngPrev === "Si";
      let alb = this.state.selectedAlb === "Si";
      let fevi = this.state.fevi ? this.state.fevi : null;
      if (
        this.state.medicalData._id.length >= 24 &&
        this.state.currentDiabetes.control === this.state.control
      ) {
        request
          .put("api/v1/diabetes/")
          .set("Authorization", "Bearer " + getToken())
          .send({
            diabetes: {
              _id: this.state.currentDiabetes._id,
              duracionDm: parseInt(this.state.duracionDm),
              presSistolica: this.state.presSistolica,
              hba1c: this.state.hba1c,
              control: this.state.currentDiabetes.control,
              albuminuria: alb,
              iamPrevDm: iam,
              iccPrev: icc,
              acvPrev: acv,
              anginaPre: ang,
              fevi: fevi,
              pieDiabeValue: this.state.pieDiabeValue,
              claseFuncional: this.state.funcional,
              clasificacionFase: this.state.fase,
              ojos: parseInt(this.state.ojosValue),
              rinon: parseInt(this.state.rinonValue),
              neuropatia: parseInt(this.state.neuroValue),
              cerebroVascular: parseInt(this.state.cerebroValue),
              corazon: parseInt(this.state.corazonValue),
              vascularPeriferico: parseInt(this.state.vascularValue),
              metabolico: parseInt(this.state.metabValue)
            }
          })
          .set("Accept", "application/json")
          .end((err, res) => {
            if (err || !res.ok) {
              this.refs.container.error(
                "Algo inesperado paso y no se pudo guardar la información",
                "",
                {
                  closeButton: true
                }
              );
            } else {
              this.refs.container.success(
                "<3 Los datos de diabetes se actualizaron correctamente",
                "Datos del control de diabetes fueron actualizados",
                {
                  closeButton: true
                }
              );
              this.setState({ modal: false, overlymain: "hide" });
            }
          });
      } else {
        saveFunctionDiab();
      }
    }
  }
  mouseOverHandler(e) {
    if (this.state.TIMESTAMP)
      this.setState({ [`className${e.target.id}`]: "date" });
  }
  mouseOutHandler(e) {
    this.setState({ [`className${e.target.id}`]: "hide" });
  }
  loadDataForm() {
    let arrayDataLabels = [];

    let labelsColumnOne = [
      "P.A. parado",
      "P.A. sentado",
      "F.C.",
      "Peso",
      "Altura",
      "IMC",
      "P. Abdominal",
      "B. Neuromuscular",
      "ITB",
      "Fuma",
      "VOP",
      "Tiempo 5 m",
      "Temperatura"
    ];
    let labelsColumnFour = [
      "Colesterol total",
      "Colesterol LDL",
      "Colesterol HDL",
      "Creatinina",
      "Trigliceridos",
      "Glicemia"
    ];
    let labelsDiabetesOne = [
      "Número de controls",
      "Evaluación pie diabético",
      "FEVI",
      "Clase funcional",
      "Clasificación segun fase",
      "IAM previo",
      "ICC previa"
    ];
    let labelsDiabetesTwo = [
      "ACV previa",
      "Angina previa",
      "Albuminuria",
      "HbA1c",
      "Presión sistólica",
      "Tiempo con diabetes",
      "Año de inicio diabetes"
    ];
    let labelsDiabetesThree = [
      "Ojos",
      "Riñon",
      "Neuropatía",
      "Cerebrovascular",
      "Corazón",
      "Vascular periférico",
      "Metabólico"
    ];
    /*let labelsNumber = [
        {
          name: "one",
          color:"color-three",
          number: 1
        },
        {
          name: "two",
          color:"color-ten",
          number: 2
        },
        {
          name: "three",
          color:"color-nine",
          number: 3
        },
        {
          name: "four",
          color:"color-eight",
          number: 4
        },
        {
          name: "five",
          color:"color-seven",
          number: 5
        },
        {
          name: "six",
          color:"color-six",
          number: 6
        },
        {
          name: "seven",
          color:"color-two",
          number: 7
        },
        {
          name: "eight",
          color:"color-five",
          number: 8
        },
        {
          name: "nine",
          color:"color-four",
          number: 9
        },
        {
          name: "ten",
          color:"color-one",
          number: 10
        }
      ]*/
    let labelsInfoColumnOne = [
      "P.A. Parado",
      "P.A. sentado",
      "F.C.",
      "Peso",
      "Altura",
      "IMC",
      "P. Abdominal",
      "B. Neuromuscular (I / D)",
      "ITB (I / D)",
      "VOP",
      "Fuma",
      "Tiempo 5 m",
      "Temperatura"
    ];
    let optionsDiabetes = [
      {
        fase: [
          { value: "", content: "" },
          { value: "I", content: "I" },
          { value: "II", content: "II" },
          { value: "III", content: "III" },
          { value: "IV", content: "IV" }
        ],
        funcional: [
          { value: "", content: "" },
          { value: "1", content: "1" },
          { value: "2", content: "2" },
          { value: "3A", content: "3A" },
          { value: "3B", content: "3B" }
        ],
        ojos: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          { value: "1", content: "Enfermedad oftalmológica diabética" },
          {
            value: "2",
            content: "Retinopatía proliferativa desprendimiento ceguera"
          }
        ],
        rinon: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          {
            value: "1",
            content:
              "Nefropatía diabética (nefritis, nefrosis, microalbuminuria)"
          },
          {
            value: "2",
            content: "Enf. Renal crónica, insuficiencia renal (cr &gt; 2mg%)"
          }
        ],
        neurop: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          {
            value: "1",
            content: "Neuropatía diabética (cualquier problema o complicación)"
          }
        ],
        cerebro: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          { value: "1", content: "Isquemia cerebral transitoria" },
          { value: "2", content: "Accidente cerebrovascular" }
        ],
        corazon: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          {
            value: "1",
            content: "Angina y otras formas de cardiopatía isquémica"
          },
          { value: "2", content: "IM, FA, ICC, aneurisma/disección" }
        ],
        vper: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          {
            value: "1",
            content: "Enfermedad vascular periférica, claudicación"
          },
          {
            value: "2",
            content: "Trombosis, embolia, gangrena, ulcera activa (MsIs)"
          }
        ],
        metab: [
          { value: null, content: "" },
          { value: "0", content: "Ninguna" },
          { value: "1", content: "Cetoacidosis, coma hiperosmolar" },
          { value: "2", content: "Hipoglicemia severa" }
        ]
      }
    ];
    arrayDataLabels.push({
      labelsColumnOne: labelsColumnOne,
      labelsColumnFour: labelsColumnFour,
      labelsDiabetesOne: labelsDiabetesOne,
      labelsDiabetesTwo: labelsDiabetesTwo,
      labelsDiabetesThree: labelsDiabetesThree,
      //labelsNumber        : labelsNumber,
      labelsInfoColumnOne: labelsInfoColumnOne,
      optionsDiabetes: optionsDiabetes
    });

    return arrayDataLabels;
  }

  render() {
    var rol = this.state.currentRol;
    var controlN = this.state.newControl;
    var sistolica =
      (parseInt(this.state.presionParadoAlta) +
        parseInt(this.state.presionSentadoAlta)) /
      2;
    document.title = "Información Médica - CORE 3.0";
    var settings = {
      backgroundColor: "#1A3B4E",
      color: "#ffffff",
      width: "50%",
      height: "auto",
      border: "1px solid #FFFFFF",
      fontSize: "14px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "1300"
    };
    var tabs;
    if (!_.isEmpty(this.state.all)) {

      let arrayElements = this.state.all;
      arrayElements;
      tabs = arrayElements.map(function (item, index) {
        let classtab =
          arrayElements.length - 1 == index
            ? "tab-control tab-control-selected"
            : "tab-control";
        let name = "Línea Base";
        let lastMonth = "";
        if (index >= 1) {
          let timestamp = arrayElements[index - 1].timestamp;
          lastMonth = moment(item.timestamp, "x").diff(
            moment(timestamp, "x").format(),
            "months"
          );
        }
        if (index >= 1) {
          if (
            rol === "enfermero" &&
            (item.control != "0") | (item.control != 0) &&
            controlN === true &&
            index === arrayElements.length - 1
          ) {
            name = "Precontrol";
          } else if (item.control === "Precontrol") {
            name = item.control;
          } else {
            name = `Control ${item.control}`;
          }
        }

        let date_ =
          item.timestamp !== null
            ? moment(item.timestamp, "x").format("DD/MM/YYYY")
            : moment().format("DD-MM-YYYY");
        date_ = lastMonth !== "" ? `${date_} (${lastMonth})` : `${date_} (--)`;
        // console.log(that.deleteControl)
        return (
          <div className={classtab} id={item._id} ref={item._id}>
            <span>{name}</span>
            <br />
            <span id={item._id} className="date">
              {date_}
            </span>
          </div>
        );
      });
    }

    var profilePicture = this.state.patientImage
      ? this.state.patientImage
      : DefaultPicture;
    var year = new Date().getFullYear();

    let arrayDataLabels = this.loadDataForm();

    var tmpboolena =
      String(this.state.ojosValue) != "" &&
      String(this.state.rinonValue) != "" &&
      String(this.state.corazonValue) != "" &&
      String(this.state.neuroValue) != "" &&
      String(this.state.cerebroValue) != "" &&
      String(this.state.vascularValue) != "" &&
      String(this.state.metabValue) != "";
    // console.log("control: ", this.state.control);
    return (
      <div className="medical">
        <ReactModal
          className="modal-new"
          isOpen={this.state.showModal}
          contentLabel="Minimal Modal Example"
          overlayClassName="Overlay"
        >
          <p className="warning">
            Aun no ha pasado un mes desde que se creo el ultimo control desea
            crear un nuevo control
          </p>
          <div className="allwidth">
            <button
              className="cancelFunction"
              onClick={this.handleCloseModal.bind(this)}
            >
              Cancelar
            </button>
            <button
              className="nextFunction"
              onClick={this.handleContinueModal.bind(this)}
            >
              Continuar
            </button>
          </div>
        </ReactModal>
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="container"
          className="toast-top-right"
        />
        <div className="header">
          <NavigationBar dirty={this.state.dirty} />
        </div>
        <div className="main-data-container">
          <div className={this.state.overlymain} />

          <div className="controls-bar" onClick={this.tabControl.bind(this)}>
            {tabs}

            {this.state.control != "Precontrol" &&
              this.state.showAddControl === true ? (
                this.state.muerto ? (
                  ""
                ) : (
                    <div
                      id="addControl"
                      className="add-control"
                      onClick={this.addControll.bind(this)}
                    >
                      Agregar Control <span className="plus">+</span>
                    </div>
                  )
              ) : (
                ""
              )}
          </div>
          <div className="table-menu" onClick={this.clickBack.bind(this)}>
            {" "}
            Tabla <a className="icon-table" />
          </div>
          <div className={this.state.editionMode}>
            <div className="control-data base-information">
              <div
                className="personal-information"
                onClick={this.cancelFunction.bind(this)}
              >
                <div className="image-container">
                  <img
                    id="photo"
                    className="patient-photo-printable"
                    src={profilePicture}
                  />
                </div>
                <div className="patient-data">
                  <label>{this.state.patientFullName}</label>
                  <label>{this.state.patientIdentificationDoc}</label>
                  <label>
                    Edad: {this.state.patientAge + " años"}
                    {this.state.patientAge < 25 ||
                      this.state.patientAge > 80 ? (
                        <img className="range-warning-image" src={warningData} />
                      ) : null}
                  </label>
                  {this.state.muerto ? (
                    <label className="dead">Falleció</label>
                  ) : (
                      ""
                    )}
                  {this.state.muerto ? (
                    <label className="date"> {this.state.date_muerte}</label>
                  ) : (
                      ""
                    )}
                </div>
              </div>
              <div className="base-medical-data">
                <div
                  className="overly"
                  style={{ position: this.state.positionMedical }}
                />
                <div className="lock-bar">
                  {this.state.basicUnlockSymbol === "" ? (
                    ""
                  ) : (
                      <img
                        src={this.state.basicUnlockSymbol}
                        className="lock-section"
                        onClick={() =>
                          this.state.basicUnlockSymbol === lock
                            ? this.refs.passwordData.show()
                            : ""
                        }
                      />
                    )}
                  <SkyLight
                    dialogStyles={settings}
                    ref="passwordData"
                    hideOnOverlayClicked
                    title="Desbloquear edición de datos"
                  >
                    <p>
                      Ingrese nuevamente su contraseña para desbloquer la
                      edición de los campos. Recuerde que pasadas 24 horas la
                      edición se bloqueará nuevamente.
                    </p>
                    <div className="password-confirm-container">
                      <input
                        className={this.state.inpErrorClass}
                        id="passwordConfirm"
                        ref="passwordConfirm"
                        type="password"
                        placeholder="Contraseña..."
                      />
                      <span className={this.state.errorMessage}>
                        {this.state.incPass}
                      </span>
                      <div
                        className="diabetes-section save-b-section"
                        onClick={this.unlockData.bind(this)}
                      >
                        <div className="diabetes-button">Editar campos</div>
                      </div>
                    </div>
                  </SkyLight>
                </div>
                <div className="medical-data">
                  <div className="data-label">
                    {arrayDataLabels[0].labelsColumnOne.map(label => (
                      <label className="medical-tag">{label}</label>
                    ))}
                  </div>
                  <div className="data-fields">
                    <div className="medical-form-group">
                      <input
                        className={this.state.arr[0]}
                        disabled={this.state.disableInputsState}
                        id="paparado"
                        ref="paparado"
                        type="number"
                        value={this.state.presionParadoAlta}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.presionParadoAltaChange.bind(this)}
                      />
                      <span className={this.state.classNamepaparado}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, "").format(
                            "DD-MM-YYYY"
                          )
                          : ""}
                      </span>
                      <span className="field-separator">/</span>
                      <input
                        className={this.state.arr[1]}
                        disabled={this.state.disableInputsState}
                        id="paparado_n"
                        ref="paparado_n"
                        type="number"
                        value={this.state.presionParadoBaja}
                        onChange={this.presionParadoBajaChange.bind(this)}
                      />
                    </div>

                    <div className="medical-form-group">
                      <input
                        id="psentado"
                        ref="psentado"
                        disabled={this.state.disableInputsState}
                        type="number"
                        className={this.state.arr[2]}
                        value={this.state.presionSentadoAlta}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.presionSentadoAltaChange.bind(this)}
                      />
                      <span className={this.state.classNamepsentado}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, "").format(
                            "DD-MM-YYYY"
                          )
                          : ""}
                      </span>
                      <span className="field-separator">/</span>
                      <input
                        id="psentado_n"
                        ref="psentado_n"
                        disabled={this.state.disableInputsState}
                        type="number"
                        className={this.state.arr[3]}
                        value={this.state.presionSentadoBaja}
                        onChange={this.presionSentadoBajaChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="frecuencia"
                        ref="frecuencia"
                        disabled={this.state.disableInputsState}
                        type="number"
                        className={this.state.arr[4]}
                        value={this.state.frecuencia}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.frecuenciaChange.bind(this)}
                      />
                      <span className={this.state.classNamefrecuencia}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, "").format(
                            "DD-MM-YYYY"
                          )
                          : ""}
                      </span>
                      <span className="field-data">LPM</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="peso"
                        ref="peso"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[5]}
                        value={this.state.peso}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.pesoChange.bind(this)}
                      />
                      <span className={this.state.classNamepeso}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, "").format(
                            "DD-MM-YYYY"
                          )
                          : ""}
                      </span>
                      <span className="field-data">Kg</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="altura"
                        ref="altura"
                        type="number"
                        className={this.state.arr[6]}
                        disabled={this.state.disableInputsState}
                        value={this.state.altura}
                        onMouseOver={this.mouseOverHandler.bind(this)}
                        onMouseOut={this.mouseOutHandler.bind(this)}
                        onChange={this.alturaChange.bind(this)}
                      />
                      <span className={this.state.classNamealtura}>
                        {this.state.TIMESTAMP
                          ? moment(this.state.TIMESTAMP * 1000, "").format(
                            "DD-MM-YYYY"
                          )
                          : ""}
                      </span>
                      <span className="field-data">cm</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="imc"
                        ref="imc"
                        className="data-input"
                        disabled="true"
                        value={this.state.imc}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="pabdominal"
                        ref="pabdominal"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[7]}
                        value={this.state.pabdominal}
                        onChange={this.pAbdominalChange.bind(this)}
                      />
                      <span className="field-data">cm</span>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="balancen"
                        ref="balancen"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[8]}
                        value={this.state.balanceNeuroIMuscular}
                        onChange={this.balanceNeuroIMuscularChange.bind(this)}
                      />
                      <input
                        id="balancend"
                        ref="balancend"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[9]}
                        value={this.state.balanceNeuroDMuscular}
                        onChange={this.balanceNeuroDMuscularChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="itbi"
                        ref="itbi"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[10]}
                        value={this.state.itbi}
                        onChange={this.itbiChange.bind(this)}
                      />
                      <input
                        id="itbd"
                        ref="itbd"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[11]}
                        value={this.state.itbd}
                        onChange={this.itbdChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <RadioGroup
                        id="smokegroup"
                        ref="smokegroup"
                        name="smoke-group"
                        selectedValue={
                          this.state.medicalData.fuma
                            ? this.state.medicalData.fuma
                            : this.state.selectedValue
                        }
                        onChange={this.smokeSelection.bind(this)}
                      >
                        {Radio => (
                          <div className="yesno-medical-container">
                            <Radio
                              id="yes"
                              ref="yes"
                              disabled={this.state.disableInputsState}
                              name="smoke-group"
                              type="radio"
                              value="Si"
                              className="yesno-medical-switch-input"
                            />
                            <label
                              htmlFor="yes"
                              className="yesno-medical-switch-label"
                            >
                              Si
                            </label>
                            <Radio
                              id="no"
                              ref="notinput"
                              disabled={this.state.disableInputsState}
                              name="smoke-group"
                              type="radio"
                              value="No"
                              className="yesno-medical-switch-input"
                            />
                            <label
                              htmlFor="no"
                              className="yesno-medical-switch-label"
                            >
                              No
                            </label>
                          </div>
                        )}
                      </RadioGroup>
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="vop"
                        ref="vop"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[12]}
                        value={this.state.vop}
                        onChange={this.vopChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="meters"
                        ref="meters"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[13]}
                        value={this.state.tiempoCincoM}
                        onChange={this.tiempoCincoMChange.bind(this)}
                      />
                    </div>
                    <div className="medical-form-group">
                      <input
                        id="temperatura"
                        ref="temperatura"
                        type="number"
                        disabled={this.state.disableInputsState}
                        className={this.state.arr[14]}
                        value={this.state.temperatura}
                        onChange={this.temperaturaChange.bind(this)}
                      />
                      <span className="field-data">ºC</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="control-data emotional-information">
              <div className="emotional-data">
                <div
                  className="overly"
                  style={{ position: this.state.positionEmotional }}
                />
                <div className="lock-bar">
                  {this.state.emotiUnlockSymbol === "" ? (
                    ""
                  ) : (
                      <img
                        src={this.state.emotiUnlockSymbol}
                        className="lock-section"
                        onClick={() =>
                          this.state.emotiUnlockSymbol === lock
                            ? this.refs.passwordData.show()
                            : ""
                        }
                      />
                    )}
                </div>
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>
                      ¿En general qué tan satisfecho está con su vida hasta
                      ahora?
                    </div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="satisfied"
                      ref="satisfied"
                      name="satisfied-group"
                      selectedValue={
                        this.state.medicalData.satisfaccion
                          ? String(this.state.medicalData.satisfaccion)
                          : this.state.satisfiedSelectedValue
                      }
                      onChange={this.satisfiedSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="satisfied-one"
                            ref="satisfied-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-one"
                            className="medical-feel-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="satisfied-two"
                            ref="satisfied-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-two"
                            className="medical-feel-label color-ten"
                          >
                            2
                          </label>
                          <Radio
                            id="satisfied-three"
                            ref="satisfied-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-three"
                            className="medical-feel-label color-nine"
                          >
                            3
                          </label>
                          <Radio
                            id="satisfied-four"
                            ref="satisfied-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-four"
                            className="medical-feel-label color-eight"
                          >
                            4
                          </label>
                          <Radio
                            id="satisfied-five"
                            ref="satisfied-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-five"
                            className="medical-feel-label color-seven"
                          >
                            5
                          </label>
                          <Radio
                            id="satisfied-six"
                            ref="satisfied-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-six"
                            className="medical-feel-label color-six"
                          >
                            6
                          </label>
                          <Radio
                            id="satisfied-seven"
                            ref="satisfied-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-seven"
                            className="medical-feel-label color-two"
                          >
                            7
                          </label>
                          <Radio
                            id="satisfied-eight"
                            ref="satisfied-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-eight"
                            className="medical-feel-label color-five"
                          >
                            8
                          </label>
                          <Radio
                            id="satisfied-nine"
                            ref="satisfied-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-nine"
                            className="medical-feel-label color-four"
                          >
                            9
                          </label>
                          <Radio
                            id="satisfied-ten"
                            ref="satisfied-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="satisfied-ten"
                            className="medical-feel-label color-one"
                          >
                            10
                          </label>
                        </div>
                        /*arrayDataLabels[0].labelsNumber.map((label) =>
                                                    <Radio id={`satisfied-${label.name}`} ref={`satisfied-${label.name}`} disabled={this.state.disableInputsState} type='radio' value={label.number} className='medical-switch-input'/>
                                                    <label htmlFor={`satisfied-${label.name}`} className={`medical-feel-label color-${label.color}`}>{label.number}</label>
                                                ) */
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>
                      ¿En general en que medida usted siente que las cosas que
                      hace valen la pena?
                    </div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="feeling"
                      ref="feeling"
                      name="feeling-group"
                      selectedValue={
                        this.state.medicalData.depresion
                          ? String(this.state.medicalData.depresion)
                          : this.state.transcendenceSelectedValue
                      }
                      onChange={this.transcendenceSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="feeling-one"
                            ref="feeling-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-one"
                            className="medical-feel-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="feeling-two"
                            ref="feeling-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-two"
                            className="medical-feel-label color-ten"
                          >
                            2
                          </label>
                          <Radio
                            id="feeling-three"
                            ref="feeling-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-three"
                            className="medical-feel-label color-nine"
                          >
                            3
                          </label>
                          <Radio
                            id="feeling-four"
                            ref="feeling-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-four"
                            className="medical-feel-label color-eight"
                          >
                            4
                          </label>
                          <Radio
                            id="feeling-five"
                            ref="feeling-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-five"
                            className="medical-feel-label color-seven"
                          >
                            5
                          </label>
                          <Radio
                            id="feeling-six"
                            ref="feeling-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-six"
                            className="medical-feel-label color-six"
                          >
                            6
                          </label>
                          <Radio
                            id="feeling-seven"
                            ref="feeling-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-seven"
                            className="medical-feel-label color-two"
                          >
                            7
                          </label>
                          <Radio
                            id="feeling-eight"
                            ref="feeling-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-eight"
                            className="medical-feel-label color-five"
                          >
                            8
                          </label>
                          <Radio
                            id="feeling-nine"
                            ref="feeling-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-nine"
                            className="medical-feel-label color-four"
                          >
                            9
                          </label>
                          <Radio
                            id="feeling-ten"
                            ref="feeling-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="feeling-ten"
                            className="medical-feel-label color-one"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>¿Estuvo feliz?</div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="happiness"
                      ref="happiness"
                      name="happiness-group"
                      selectedValue={
                        this.state.medicalData.feliz
                          ? String(this.state.medicalData.feliz)
                          : this.state.happinessSelectedValue
                      }
                      onChange={this.happinessSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="happiness-one"
                            ref="happiness-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-one"
                            className="medical-feel-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="happiness-two"
                            ref="happiness-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-two"
                            className="medical-feel-label color-ten"
                          >
                            2
                          </label>
                          <Radio
                            id="happiness-three"
                            ref="happiness-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-three"
                            className="medical-feel-label color-nine"
                          >
                            3
                          </label>
                          <Radio
                            id="happiness-four"
                            ref="happiness-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-four"
                            className="medical-feel-label color-eight"
                          >
                            4
                          </label>
                          <Radio
                            id="happiness-five"
                            ref="happiness-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-five"
                            className="medical-feel-label color-seven"
                          >
                            5
                          </label>
                          <Radio
                            id="happiness-six"
                            ref="happiness-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-six"
                            className="medical-feel-label color-six"
                          >
                            6
                          </label>
                          <Radio
                            id="happiness-seven"
                            ref="happiness-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-seven"
                            className="medical-feel-label color-two"
                          >
                            7
                          </label>
                          <Radio
                            id="happiness-eight"
                            ref="happiness-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-eight"
                            className="medical-feel-label color-five"
                          >
                            8
                          </label>
                          <Radio
                            id="happiness-nine"
                            ref="happiness-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-nine"
                            className="medical-feel-label color-four"
                          >
                            9
                          </label>
                          <Radio
                            id="happiness-ten"
                            ref="happiness-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="happiness-ten"
                            className="medical-feel-label color-one"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>¿Estuvo preocupado(a)?</div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="worried"
                      ref="worried"
                      name="worried-group"
                      selectedValue={
                        this.state.medicalData.preocupacion
                          ? String(this.state.medicalData.preocupacion)
                          : this.state.worriedSelectedValue
                      }
                      onChange={this.worriedSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="worried-one"
                            ref="worried-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-one"
                            className="medical-feel-label color-one"
                          >
                            1
                          </label>
                          <Radio
                            id="worried-two"
                            ref="worried-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-two"
                            className="medical-feel-label color-four"
                          >
                            2
                          </label>
                          <Radio
                            id="worried-three"
                            ref="worried-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-three"
                            className="medical-feel-label color-five"
                          >
                            3
                          </label>
                          <Radio
                            id="worried-four"
                            ref="worried-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-four"
                            className="medical-feel-label color-two"
                          >
                            4
                          </label>
                          <Radio
                            id="worried-five"
                            ref="worried-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-five"
                            className="medical-feel-label color-six"
                          >
                            5
                          </label>
                          <Radio
                            id="worried-six"
                            ref="worried-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-six"
                            className="medical-feel-label color-seven"
                          >
                            6
                          </label>
                          <Radio
                            id="worried-seven"
                            ref="worried-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-seven"
                            className="medical-feel-label color-eight"
                          >
                            7
                          </label>
                          <Radio
                            id="worried-eight"
                            ref="worried-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-eight"
                            className="medical-feel-label color-nine"
                          >
                            8
                          </label>
                          <Radio
                            id="worried-nine"
                            ref="worried-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-nine"
                            className="medical-feel-label color-ten"
                          >
                            9
                          </label>
                          <Radio
                            id="worried-ten"
                            ref="worried-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="worried-ten"
                            className="medical-feel-label color-three"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
                <img className="image-h-separator" src={HSeparator} />
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>¿Estuvo dacaído(a)?</div>
                  </div>
                  <div className="form-input-container">
                    <RadioGroup
                      id="dec"
                      ref="dec"
                      name="dec-group"
                      selectedValue={
                        this.state.medicalData.decaido
                          ? String(this.state.medicalData.decaido)
                          : this.state.decSelectedValue
                      }
                      onChange={this.decSelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-feel-container">
                          <Radio
                            id="dec-one"
                            ref="dec-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-one"
                            className="medical-feel-label color-one"
                          >
                            1
                          </label>
                          <Radio
                            id="dec-two"
                            ref="dec-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-two"
                            className="medical-feel-label color-four"
                          >
                            2
                          </label>
                          <Radio
                            id="dec-three"
                            ref="dec-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-three"
                            className="medical-feel-label color-five"
                          >
                            3
                          </label>
                          <Radio
                            id="dec-four"
                            ref="dec-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-four"
                            className="medical-feel-label color-two"
                          >
                            4
                          </label>
                          <Radio
                            id="dec-five"
                            ref="dec-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-five"
                            className="medical-feel-label color-six"
                          >
                            5
                          </label>
                          <Radio
                            id="dec-six"
                            ref="dec-six"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="6"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-six"
                            className="medical-feel-label color-seven"
                          >
                            6
                          </label>
                          <Radio
                            id="dec-seven"
                            ref="dec-seven"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="7"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-seven"
                            className="medical-feel-label color-eight"
                          >
                            7
                          </label>
                          <Radio
                            id="dec-eight"
                            ref="dec-eight"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="8"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-eight"
                            className="medical-feel-label color-nine"
                          >
                            8
                          </label>
                          <Radio
                            id="dec-nine"
                            ref="dec-nine"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="9"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-nine"
                            className="medical-feel-label color-ten"
                          >
                            9
                          </label>
                          <Radio
                            id="dec-ten"
                            ref="dec-ten"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="10"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="dec-ten"
                            className="medical-feel-label color-three"
                          >
                            10
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                </div>
              </div>
              <div className="activity-data">
                <div
                  className="overly"
                  style={{ position: this.state.positionActivity }}
                />
                <div className="lock-bar">
                  {this.state.activUnlockSymbol === "" ? (
                    ""
                  ) : (
                      <img
                        src={this.state.activUnlockSymbol}
                        className="lock-section"
                        onClick={() =>
                          this.state.activUnlockSymbol === lock
                            ? this.refs.passwordData.show()
                            : ""
                        }
                      />
                    )}
                </div>
                <div className="physical-section">
                  <div className="physical-label-container">
                    <div>
                      Elija la categoría que mejor describe su rutina cotidiana
                      de actividad física
                    </div>
                  </div>
                  <div className="physical-component-field">
                    <RadioGroup
                      id="phy"
                      ref="phy"
                      name="phy-group"
                      selectedValue={
                        this.state.medicalData.mets
                          ? String(this.state.medicalData.mets)
                          : this.state.phySelectedValue
                      }
                      onChange={this.phySelection.bind(this)}
                    >
                      {Radio => (
                        <div className="medical-switch-container">
                          <Radio
                            id="phy-one"
                            ref="phy-one"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="1"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-one"
                            className="medical-switch-label color-three"
                          >
                            1
                          </label>
                          <Radio
                            id="phy-two"
                            ref="phy-two"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="2"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-two"
                            className="medical-switch-label color-two"
                          >
                            2
                          </label>
                          <Radio
                            id="phy-three"
                            ref="phy-three"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="3"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-three"
                            className="medical-switch-label color-five"
                          >
                            3
                          </label>
                          <Radio
                            id="phy-four"
                            ref="phy-four"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="4"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-four"
                            className="medical-switch-label color-four"
                          >
                            4
                          </label>
                          <Radio
                            id="phy-five"
                            ref="phy-five"
                            disabled={this.state.disableInputsState}
                            type="radio"
                            value="5"
                            className="medical-switch-input"
                          />
                          <label
                            htmlFor="phy-five"
                            className="medical-switch-label color-one"
                          >
                            5
                          </label>
                        </div>
                      )}
                    </RadioGroup>
                  </div>
                  <div className="emotional-state">{this.state.phyText}</div>
                </div>
              </div>
            </div>
            <div className="control-data movility-information">
              <div
                className="overly"
                style={{ position: this.state.positionPhysical }}
              />
              <div className="lock-bar">
                {this.state.physiUnlockSymbol === "" ? (
                  ""
                ) : (
                    <img
                      src={this.state.physiUnlockSymbol}
                      className="lock-section"
                      onClick={() =>
                        this.state.physiUnlockSymbol === lock
                          ? this.refs.passwordData.show()
                          : ""
                      }
                    />
                  )}
              </div>
              <div className="data-form patient-emotion-data">
                <div className="emotional-fields-container">
                  <div className="emotional-field">
                    <div className="form-group-emotional">
                      <div className="emotional-container-label">Movilidad</div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="mov"
                          ref="mov"
                          name="mov-group"
                          selectedValue={
                            this.state.medicalData.movilidad
                              ? String(this.state.medicalData.movilidad)
                              : this.state.movSelectedValue
                          }
                          onChange={this.movSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="mov-one"
                                disabled={this.state.disableInputsState}
                                ref="mov-one"
                                name="mov-group"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="mov-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="mov-two"
                                disabled={this.state.disableInputsState}
                                ref="mov-two"
                                name="mov-group"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="mov-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="mov-three"
                                disabled={this.state.disableInputsState}
                                ref="mov-three"
                                name="mov-group"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="mov-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">
                        {this.state.movText}
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Cuidado Personal
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="cp"
                          ref="cp"
                          name="cp-group"
                          selectedValue={
                            this.state.medicalData.cuidadoPersonal
                              ? String(this.state.medicalData.cuidadoPersonal)
                              : this.state.cpSelectedValue
                          }
                          onChange={this.cpSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="cp-one"
                                ref="cp-one"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="cp-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="cp-two"
                                ref="cp-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="cp-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="cp-three"
                                ref="cp-three"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="cp-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">{this.state.cpText}</div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Actividades Cotidianas
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="actco"
                          ref="actco"
                          name="actco-group"
                          selectedValue={
                            this.state.medicalData.actividadesCotidianas
                              ? String(
                                this.state.medicalData.actividadesCotidianas
                              )
                              : this.state.actcoSelectedValue
                          }
                          onChange={this.actcoSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="actco-one"
                                ref="actco-one"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="actco-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="actco-two"
                                ref="actco-two"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="actco-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="actco-three"
                                ref="actco-three"
                                disabled={this.state.disableInputsState}
                                name="chooser"
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="actco-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                        <div
                          id="resactco"
                          ref="resactco"
                          className="switched-result"
                        />
                      </div>
                      <div className="emotional-state">
                        {this.state.actcoText}
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Dolor / Malestar
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="dm"
                          ref="dm"
                          name="dm-group"
                          selectedValue={
                            this.state.medicalData.dolor
                              ? String(this.state.medicalData.dolor)
                              : this.state.dmSelectedValue
                          }
                          onChange={this.dmSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="dm-one"
                                ref="dm-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="dm-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="dm-two"
                                ref="dm-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="dm-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="dm-three"
                                ref="dm-three"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="dm-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">{this.state.dmText}</div>
                      <img className="image-h-separator" src={HSeparator} />
                    </div>

                    <div className="form-group-emotional">
                      <div className="emotional-container-label">
                        Ansiedad / Depresión
                      </div>
                      <div className="emotional-component-field">
                        <RadioGroup
                          id="ansdep"
                          ref="ansdep"
                          name="ansdep-group"
                          selectedValue={
                            this.state.medicalData.ansiedad
                              ? String(this.state.medicalData.ansiedad)
                              : this.state.ansdepSelectedValue
                          }
                          onChange={this.ansdepSelection.bind(this)}
                        >
                          {Radio => (
                            <div className="medical-switch-container">
                              <Radio
                                id="ansdep-one"
                                ref="ansdep-one"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="1"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="ansdep-one"
                                className="medical-switch-label color-one"
                              >
                                1
                              </label>
                              <Radio
                                id="ansdep-two"
                                ref="ansdep-two"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="2"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="ansdep-two"
                                className="medical-switch-label color-two"
                              >
                                2
                              </label>
                              <Radio
                                id="ansdep-three"
                                ref="ansdep-three"
                                name="chooser"
                                disabled={this.state.disableInputsState}
                                type="radio"
                                value="3"
                                className="medical-switch-input"
                              />
                              <label
                                htmlFor="ansdep-three"
                                className="medical-switch-label color-three"
                              >
                                3
                              </label>
                            </div>
                          )}
                        </RadioGroup>
                      </div>
                      <div className="emotional-state">
                        {this.state.ansdepText}
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                      <div className="physical-section">
                        <div className="slider-content">
                          <div>Tu estado de salud HOY</div>
                        </div>
                        <div className="form-input-slider-container">
                          <div className="slider">
                            <Rslider
                              value={this.state.health}
                              onChange={this.healthChange.bind(this)}
                              min={1}
                              max={100}
                            />
                          </div>
                          <input
                            id="health"
                            ref="health"
                            type="number"
                            className="slider-input-class"
                            value={this.state.health}
                            onChange={this.healthInputChange.bind(this)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="control-data medical-information">
              <div className="box-medical-exams middle">
                <div className="medical-exams">
                  <div
                    className="overly"
                    style={{ position: this.state.positionExamns }}
                  />
                  <div className="exam-header">
                    <div className="exam-title">Exámenes</div>

                    <div className="exam-lock">
                      {this.state.examnUnlockSymbol === "" ? (
                        ""
                      ) : (
                          <img
                            src={this.state.examnUnlockSymbol}
                            className="lock-section"
                            onClick={() =>
                              this.state.examnUnlockSymbol === lock
                                ? this.refs.passwordData.show()
                                : ""
                            }
                          />
                        )}
                    </div>
                  </div>
                  <img className="image-h-separator" src={HSeparator} />
                  <div className="exam-content">
                    <div className="data-label label-exams">
                      {arrayDataLabels[0].labelsColumnFour.map(label => (
                        <label className="medical-tag">{label}</label>
                      ))}
                    </div>
                    <div className="data-fields fields-exams">
                      <div className="medical-form-group">
                        <input
                          id="coltotal"
                          disabled={this.state.disableInputsState}
                          ref="coltotal"
                          type="number"
                          className={this.state.arr[15]}
                          value={this.state.colesterolTotal}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.colesterolTotalChange.bind(this)}
                        />
                        <span className={this.state.classNamecoltotal}>
                          {this.state.TIMESTAMP
                            ? moment(this.state.TIMESTAMP * 1000, "").format(
                              "DD-MM-YYYY"
                            )
                            : ""}
                        </span>
                      </div>
                      <div className="medical-form-group">
                        <input
                          id="colldl"
                          disabled={this.state.disableInputsState}
                          ref="colldl"
                          type="number"
                          className={this.state.arr[16]}
                          value={this.state.colesterolLDL}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.colesterolLDLChange.bind(this)}
                        />
                        <span className={this.state.classNamecolldl}>
                          {this.state.TIMESTAMP
                            ? moment(this.state.TIMESTAMP * 1000, "").format(
                              "DD-MM-YYYY"
                            )
                            : ""}
                        </span>
                      </div>
                      <div className="medical-form-group">
                        <input
                          id="colhdl"
                          disabled={this.state.disableInputsState}
                          ref="colhdl"
                          type="number"
                          className={this.state.arr[17]}
                          value={this.state.colesterolHDL}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.colesterolHDLChange.bind(this)}
                        />
                        <span className={this.state.classNamecolhdl}>
                          {this.state.TIMESTAMP
                            ? moment(this.state.TIMESTAMP * 1000, "").format(
                              "DD-MM-YYYY"
                            )
                            : ""}
                        </span>
                      </div>
                      <div className="medical-form-group">
                        <input
                          id="creatinina"
                          disabled={this.state.disableInputsState}
                          ref="creatinina"
                          type="number"
                          className={this.state.arr[18]}
                          value={this.state.creatinina}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.creatininaChange.bind(this)}
                        />
                        <span className={this.state.classNamecreatinina}>
                          {this.state.TIMESTAMP
                            ? moment(this.state.TIMESTAMP * 1000, "").format(
                              "DD-MM-YYYY"
                            )
                            : ""}
                        </span>
                      </div>
                      <div className="medical-form-group">
                        <input
                          id="trigliceridos"
                          disabled={this.state.disableInputsState}
                          ref="trigliceridos"
                          type="number"
                          className={this.state.arr[19]}
                          value={this.state.trigliceridos}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.trigliceridosChange.bind(this)}
                        />
                        <span className={this.state.classNametrigliceridos}>
                          {this.state.TIMESTAMP
                            ? moment(this.state.TIMESTAMP * 1000, "").format(
                              "DD-MM-YYYY"
                            )
                            : ""}
                        </span>
                      </div>
                      <div className="medical-form-group">
                        <input
                          className={this.state.arr[20]}
                          id="glicemia"
                          disabled={this.state.disableInputsState}
                          ref="glicemia"
                          type="number"
                          value={this.state.glicemia}
                          onMouseOver={this.mouseOverHandler.bind(this)}
                          onMouseOut={this.mouseOutHandler.bind(this)}
                          onChange={this.glicemiaChange.bind(this)}
                        />
                        <span className={this.state.classNameglicemia}>
                          {this.state.TIMESTAMP
                            ? moment(this.state.TIMESTAMP * 1000, "").format(
                              "DD-MM-YYYY"
                            )
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.patientDiabetico === true &&
                this.state.moduleDiabetes ? (
                  <div className="box-medical-exams-diabetes">
                    <div
                      className="overly"
                      style={{ position: this.state.positionDiabetes }}
                    />
                    <div className="medical-exams">
                      <div className="exam-header">
                        <div className="exam-title">Datos diabetes</div>
                        <div className="exam-lock">
                          {this.state.diabeUnlockSymbol === "" ? (
                            ""
                          ) : (
                              <img
                                src={this.state.diabeUnlockSymbol}
                                className="lock-section"
                                onClick={() =>
                                  this.state.diabeUnlockSymbol === lock
                                    ? this.refs.passwordData.show()
                                    : ""
                                }
                              />
                            )}
                        </div>
                      </div>
                      <img className="image-h-separator" src={HSeparator} />
                      {this.state.patientDiabetico === true &&
                        !_.isEmpty(this.state.medicalData._id) &&
                        this.state.medicalData._id.length >= 24 &&
                        this.state.control !== "Precontrol" ? (
                          <div className="physical-section diabetes">
                            <div className="diabetes-section">
                              <div
                                className="diabetes-button"
                                onClick={this.diabetesModal.bind(this)}
                              >
                                Completar datos diabetes
                          </div>
                            </div>
                          </div>
                        ) : (
                          'guardar antes un control medico completo para esto debe ser con un perfil de doctor y el estado actual no debe ser "Precontrol"'
                        )}
                    </div>
                  </div>
                ) : null}
              <div className="box-medical-exams-last">
                <div className="medical-exams">
                  <div
                    className="overly"
                    style={{ position: this.state.positionNotes }}
                  />
                  <div className="exam-header">
                    <div className="exam-title">Notas</div>
                    <div className="exam-lock">
                      {this.state.notesUnlockSymbol === "" ? (
                        ""
                      ) : (
                          <img
                            src={this.state.notesUnlockSymbol}
                            className="lock-section"
                            onClick={() =>
                              this.state.notesUnlockSymbol === lock
                                ? this.refs.passwordData.show()
                                : ""
                            }
                          />
                        )}
                    </div>
                  </div>
                  <img className="image-h-separator" src={HSeparator} />
                  <div className="exam-content">
                    <div className="physics-squares-notes">
                      <textarea
                        ref="observaciones"
                        className="notes-area"
                        disabled={this.state.disableInputsState}
                        value={this.state.notasText}
                        onChange={this.handleObservaciones.bind(this)}
                      />
                    </div>
                  </div>
                  {this.state.muerto ? (
                    ""
                  ) : (
                      <div
                        className="diabetes-section save-b-section"
                        onClick={this.saveMedicalData.bind(this)}
                      >
                        <div className="diabetes-button">Guardar</div>
                      </div>
                    )}
                  <div
                    className="diabetes-section save-b-section"
                    onClick={this.cancelFunction.bind(this)}
                  >
                    <div className="diabetes-button back">
                      ⟵ Regresar al Dashboard
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={this.state.readMode}>
            <div className="data-information-container data-left">
              <div className="column-information">
                <div className="col-data data-left">
                  <div className="labels-data">
                    {arrayDataLabels[0].labelsInfoColumnOne.map(label => (
                      <label className="label-tg-name brdr-bttm">{label}</label>
                    ))}
                  </div>
                  <div className="labels-value">
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.presPRange}>
                        {this.state.presionParadoAlta} /{" "}
                        {this.state.presionParadoBaja}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.presSRange}>
                        {this.state.presionSentadoAlta} /{" "}
                        {this.state.presionSentadoBaja}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.fcRange}>
                        {this.state.frecuencia + " LPM"}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span>{this.state.peso + " Kg"}</span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      {this.state.altura + " cm"}
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.IMCRange}>
                        {this.state.imc}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.perAbdRange}>
                        {this.state.pabdominal + " cm"}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.balIzRange}>
                        {this.state.balanceNeuroIMuscular}
                      </span>&nbsp;/&nbsp;<span
                        className={this.state.balDeRange}
                      >
                        {this.state.balanceNeuroDMuscular}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.itbiRange}>
                        {this.state.itbi}
                      </span>&nbsp;/&nbsp;<span
                        className={this.state.itbdRange}
                      >
                        {this.state.itbd}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.vopRange}>
                        {this.state.vop}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.tabaqRange}>
                        {this.state.fuma}
                      </span>
                    </label>
                    <label className="label-tg-value brdr-bttm">
                      <span className={this.state.tiempo}>
                        {this.state.tiempoCincoM + " seg"}
                      </span>
                    </label>
                    <label className="label-tg-value">
                      {this.state.temperatura + " ºC"}
                    </label>
                  </div>
                </div>
                <div className="col-data-container">
                  <div className="emotional-results">
                    <div className="labels-data">
                      <label className="label-tg-name brdr-bttm">
                        Satisfacción
                      </label>
                      <label className="label-tg-name brdr-bttm">
                        Contribución
                      </label>
                      <label className="label-tg-name brdr-bttm">
                        Felicidad
                      </label>
                      <label className="label-tg-name brdr-bttm">
                        Preocupación
                      </label>
                      <label className="label-tg-name">Depresión</label>
                    </div>
                    <div className="labels-value">
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.satRange}>
                          {this.state.satisfaccion}
                        </span>
                      </label>
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.conRange}>
                          {this.state.depresion}
                        </span>
                      </label>
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.felRange}>
                          {this.state.feliz}
                        </span>
                      </label>
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.preRange}>
                          {this.state.preocupacion}
                        </span>
                      </label>
                      <label className="label-tg-value">
                        <span className={this.state.decRange}>
                          {this.state.decaido}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="single-row single-row-bottom ">
                    <div className="labels-data">
                      <label className="label-tg-name">Actividad física</label>
                    </div>
                    <div className="labels-value">
                      <label className="label-tg-value">
                        <span className={this.state.metsRange}>
                          {this.state.medicalData.mets}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="emotional-results">
                    <div className="labels-data">
                      <label className="label-tg-name brdr-bttm">
                        Movilidad
                      </label>
                      <label className="label-tg-name brdr-bttm">
                        Cuidado personal
                      </label>
                      <label className="label-tg-name brdr-bttm">
                        Actividades cotidianas
                      </label>
                      <label className="label-tg-name brdr-bttm">
                        Dolor / Malestar
                      </label>
                      <label className="label-tg-name">
                        Ansiedad / Depresión
                      </label>
                    </div>
                    <div className="labels-value">
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.movRange}>
                          {this.state.medicalData.movilidad}
                        </span>
                      </label>
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.cuiRange}>
                          {this.state.medicalData.cuidadoPersonal}
                        </span>
                      </label>
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.actRange}>
                          {this.state.medicalData.actividadesCotidianas}
                        </span>
                      </label>
                      <label className="label-tg-value brdr-bttm">
                        <span className={this.state.dolRange}>
                          {this.state.medicalData.dolor}
                        </span>
                      </label>
                      <label className="label-tg-value">
                        <span className={this.state.ansRange}>
                          {this.state.medicalData.ansiedad}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="single-row">
                    <div className="labels-data">
                      <label className="label-tg-name">Estado de salud</label>
                    </div>
                    <div className="labels-value">
                      <label className="label-tg-value">
                        {this.state.health}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="notes-information">
                <div className="notes-title">Notas</div>
                <div className="notes-author-notes-date">
                  <div className="notes-author">
                    Creado por:{" "}
                    {this.state.modificadoPor === undefined
                      ? ""
                      : this.state.creadoPor}
                  </div>
                  <div className="notes-author">
                    Modificado por:{" "}
                    {this.state.modificadoPor === undefined
                      ? ""
                      : this.state.modificadoPor}
                  </div>
                  <div className="notes-date">
                    {this.state.notasText === "" ? "" : this.state.creationDate}
                  </div>
                </div>
                <div className="notes-data">{this.state.notasText}</div>
              </div>
            </div>
            <div className="data-information-container">
              <div className="column-information-examns">
                <div className="col-data-container data-left">
                  <div className="emotional-results-diab single-row-bottom">
                    <h3>Exámenes</h3>
                    <div className="exmn-cntnt">
                      <div className="labels-data">
                        <label className="label-tg-name brdr-bttm">
                          Colesterol total
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Colesterol LDL
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Colesterol HDL
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Creatinina
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Glicemia
                        </label>
                        <label className="label-tg-name">Trigliceridos</label>
                      </div>
                      <div className="labels-value">
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.coltRange}>
                            {this.state.colesterolTotal}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.collRange}>
                            {this.state.colesterolLDL}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.colhRange}>
                            {this.state.colesterolHDL}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.creatRange}>
                            {this.state.creatinina}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          {this.state.glicemia}
                        </label>
                        <label className="label-tg-value">
                          <span className={this.state.trigRange}>
                            {this.state.trigliceridos}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    className="emotional-results-diab single-row-bottom"
                    style={{ visibility: this.state.classNameDiabetes }}
                  >
                    <h3>Diabetes</h3>
                    <div className="exmn-cntnt">
                      <div className="labels-data">
                        <label className="label-tg-name brdr-bttm">FEVI</label>
                        <label className="label-tg-name brdr-bttm">
                          Clasificación según fase
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Clase funcional
                        </label>
                        <label className="label-tg-name ">
                          Evalución pie diabético
                        </label>
                      </div>
                      <div className="labels-value">
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.feviVRange}>
                            {this.state.fevi}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.clasSRange}>
                            {this.state.fase}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.clasFRange}>
                            {this.state.funcional}
                          </span>
                        </label>
                        <label className="label-tg-value">
                          <span className={this.state.evaPDRange}>
                            {this.state.pieDiabeValue}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    className="emotional-results-diab"
                    style={{ visibility: this.state.classNameDiabetes }}
                  >
                    <div className="exmn-cntnt">
                      <div className="labels-data">
                        <label className="label-tg-name brdr-bttm">
                          IAM previo
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          ICC previo
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          ACV previo
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Angina previa
                        </label>
                        <label className="label-tg-name">Albuminuria</label>
                      </div>
                      <div className="labels-value">
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.iamRange}>
                            {this.state.IAMValue}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.iccRange}>
                            {this.state.ICCValue}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.acvRange}>
                            {this.state.ACVValue}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.angRange}>
                            {this.state.AngPrev}
                          </span>
                        </label>
                        <label className="label-tg-value">
                          <span className={this.state.albuRange}>
                            {this.state.selectedAlb}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-data-container"
                  style={{ visibility: this.state.classNameDiabetes }}
                >
                  <div className="emotional-results-diab single-row-bottom">
                    <div className="exmn-cntnt">
                      <div className="labels-data">
                        <label className="label-tg-name brdr-bttm">HbA1c</label>
                        <label className="label-tg-name brdr-bttm">
                          Presión sistólica
                        </label>
                        <label className="label-tg-name brdr-bttm">
                          Tiempo con diabetes
                        </label>
                        <label className="label-tg-name">
                          Año incio diabetes
                        </label>
                      </div>
                      <div className="labels-value">
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.hba1cRange}>
                            {this.state.hba1c}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.sistolicaRange}>
                            {sistolica}
                          </span>
                        </label>
                        <label className="label-tg-value brdr-bttm">
                          <span className={this.state.duraDRange}>
                            {this.state.duracionDm}
                          </span>
                        </label>
                        <label className="label-tg-value">
                          <span className={this.state.duraDRange}>
                            {year - this.state.duracionDm}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="emotional-results-diab-risk">
                    <div className="severity-container brdr-bttm">
                      <div className="result-complication">Ojos</div>
                      <div className="result-severity">
                        {this.state.ojosValue === 0
                          ? "Ninguna"
                          : this.state.ojosValue === 1
                            ? "Enfermedad oftalmológica diabética"
                            : this.state.ojosValue === 2
                              ? "Retinopatía proliferativa desprendimiento ceguera"
                              : ""}
                      </div>
                    </div>
                    <div className="severity-container brdr-bttm">
                      <div className="result-complication">Riñon</div>
                      <div className="result-severity">
                        {this.state.rinonValue === 0
                          ? "Ninguna"
                          : this.state.rinonValue === 1
                            ? "Nefropatía diabética (nefritis, nefrosis, microalbuminuria)"
                            : this.state.rinonValue === 2
                              ? "Enf. Renal crónica, insuficiencia renal (cr > 2mg%)"
                              : ""}
                      </div>
                    </div>
                    <div className="severity-container brdr-bttm">
                      <div className="result-complication">Neuropatía</div>
                      <div className="result-severity">
                        {this.state.neuroValue === 0
                          ? "Ninguna"
                          : this.state.neuroValue === 1
                            ? "Neuropatía diabética (cualquier problema o complicación)"
                            : ""}
                      </div>
                    </div>
                    <div className="severity-container brdr-bttm">
                      <div className="result-complication">Cerebrovascular</div>
                      <div className="result-severity">
                        {this.state.cerebroValue === 0
                          ? "Ninguna"
                          : this.state.cerebroValue === 1
                            ? "Isquemia cerebral transitoria"
                            : this.state.cerebroValue === 2
                              ? "Accidente cerebrovascular"
                              : ""}
                      </div>
                    </div>
                    <div className="severity-container brdr-bttm">
                      <div className="result-complication">Corazón</div>
                      <div className="result-severity">
                        {this.state.corazonValue === 0
                          ? "Ninguna"
                          : this.state.corazonValue === 1
                            ? "Angina y otras formas de cardiopatía isquémica"
                            : this.state.corazonValue === 2
                              ? "IM, FA, ICC, aneurisma/disección"
                              : ""}
                      </div>
                    </div>
                    <div className="severity-container brdr-bttm">
                      <div className="result-complication">
                        Vascular periférico
                      </div>
                      <div className="result-severity">
                        {this.state.vascularValue === 0
                          ? "Ninguna"
                          : this.state.vascularValue === 1
                            ? "Enfermedad vascular periférica, claudicación"
                            : this.state.vascularValue === 2
                              ? "Trombosis, embolia, gangrena, ulcera activa (MsIs)"
                              : ""}
                      </div>
                    </div>
                    <div className="severity-container">
                      <div className="result-complication">Metabólico</div>
                      <div className="result-severity">
                        {this.state.metabValue === 0
                          ? "Ninguna"
                          : this.state.metabValue === 1
                            ? "Cetoacidosis, coma hiperosmolar"
                            : this.state.metabValue === 2
                              ? "Hipoglicemia severa"
                              : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ReactModal
              className="modal modal-center"
              isOpen={this.state.modal}
              contentLabel="Minimal Modal Example"
              overlayClassName="Overlay"
            >
              <div className="header-modal-section-close">
                <img
                  className="closeModalIcon"
                  src={closeModal}
                  onClick={this.closeModal.bind(this)}
                />
              </div>
              <div className="diabetes-field-container">
                <div className="diabetes-severity-content">
                  <div className="severity-data-labels-left">
                    {arrayDataLabels[0].labelsDiabetesOne.map(label => (
                      <label className="diabetes-data-label">{label}</label>
                    ))}
                  </div>
                </div>
                <div className="severity-data-labels-center">
                  <input
                    type="text"
                    id="controlRef"
                    ref="control"
                    className="severity-input"
                    min="0"
                    max="100"
                    value={this.state.control}
                    onChange={this.controlChange.bind(this)}
                  />
                  <div className="yesno-alb-container ynleft">
                    <input
                      id="pdyes"
                      ref="pdyesinput"
                      name="yespdno"
                      type="radio"
                      value="Si"
                      className="yesno-alb-switch-input"
                      checked={this.state.pieDiabeValue === "Si"}
                      onChange={this.pieDiabeticoV.bind(this)}
                    />
                    <label htmlFor="pdyes" className="yesno-alb-switch-label">
                      Si
                    </label>
                    <input
                      id="pdno"
                      ref="pdnotinput"
                      name="yespdno"
                      type="radio"
                      value="No"
                      className="yesno-alb-switch-input"
                      checked={this.state.pieDiabeValue === "No"}
                      onChange={this.pieDiabeticoV.bind(this)}
                    />
                    <label htmlFor="pdno" className="yesno-alb-switch-label">
                      No
                    </label>
                  </div>
                  <input
                    type="number"
                    ref="fevi"
                    id="fevi"
                    className="severity-input"
                    min="0"
                    max="100"
                    value={this.state.fevi}
                    onChange={this.feviChange.bind(this)}
                  />
                  <select
                    ref="funcional"
                    id="funcional"
                    className="severity-select severity-select-firts"
                    value={this.state.funcional}
                    onChange={this.funcionalChange.bind(this)}
                  >
                    {arrayDataLabels[0].optionsDiabetes[0].fase.map(label => (
                      <option value={label.value}>{label.content}</option>
                    ))}
                  </select>
                  <select
                    ref="fase"
                    id="fase"
                    className="severity-select severity-select-firts"
                    value={this.state.fase}
                    onChange={this.faseChange.bind(this)}
                  >
                    {arrayDataLabels[0].optionsDiabetes[0].funcional.map(
                      label => (
                        <option value={label.value}>{label.content}</option>
                      )
                    )}
                  </select>
                  <div className="yesno-alb-container ynleft">
                    <input
                      id="iamyes"
                      ref="iamyesinput"
                      name="yesiamno"
                      type="radio"
                      value="Si"
                      className="yesno-alb-switch-input"
                      checked={this.state.IAMValue === "Si"}
                      onChange={this.IAMDM.bind(this)}
                    />
                    <label htmlFor="iamyes" className="yesno-alb-switch-label">
                      Si
                    </label>
                    <input
                      id="iamno"
                      ref="iamnotinput"
                      name="yesiamno"
                      type="radio"
                      value="No"
                      className="yesno-alb-switch-input"
                      checked={this.state.IAMValue === "No"}
                      onChange={this.IAMDM.bind(this)}
                    />
                    <label htmlFor="iamno" className="yesno-alb-switch-label">
                      No
                    </label>
                  </div>
                  <div className="yesno-alb-container ynleft">
                    <input
                      id="iccyes"
                      ref="iccyesinput"
                      name="yesiccno"
                      type="radio"
                      value="Si"
                      className="yesno-alb-switch-input"
                      checked={this.state.ICCValue === "Si"}
                      onChange={this.ICCDM.bind(this)}
                    />
                    <label htmlFor="iccyes" className="yesno-alb-switch-label">
                      Si
                    </label>
                    <input
                      id="iccno"
                      ref="iccnotinput"
                      name="yesiccno"
                      type="radio"
                      value="No"
                      className="yesno-alb-switch-input"
                      checked={this.state.ICCValue === "No"}
                      onChange={this.ICCDM.bind(this)}
                    />
                    <label htmlFor="iccno" className="yesno-alb-switch-label">
                      No
                    </label>
                  </div>
                </div>
                <div className="diabetes-severity-content">
                  <div className="severity-data-labels-right">
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                  </div>
                </div>
                <div className="diabetes-severity-content left-lb">
                  <div className="severity-data-labels-left">
                    {arrayDataLabels[0].labelsDiabetesTwo.map(label => (
                      <label className="diabetes-data-label">{label}</label>
                    ))}
                  </div>
                </div>
                <div className="severity-data-labels-center">
                  <div className="yesno-alb-container ynleft">
                    <input
                      id="acvyes"
                      ref="acvyesinput"
                      name="yesacvno"
                      type="radio"
                      value="Si"
                      className="yesno-alb-switch-input"
                      checked={this.state.ACVValue === "Si"}
                      onChange={this.ACVVAL.bind(this)}
                    />
                    <label htmlFor="acvyes" className="yesno-alb-switch-label">
                      Si
                    </label>
                    <input
                      id="acvno"
                      ref="acvnotinput"
                      name="yesacvno"
                      type="radio"
                      value="No"
                      className="yesno-alb-switch-input"
                      checked={this.state.ACVValue === "No"}
                      onChange={this.ACVVAL.bind(this)}
                    />
                    <label htmlFor="acvno" className="yesno-alb-switch-label">
                      No
                    </label>
                  </div>
                  <div className="yesno-alb-container ynleft">
                    <input
                      id="angyes"
                      ref="angyesinput"
                      name="yesangno"
                      type="radio"
                      value="Si"
                      className="yesno-alb-switch-input"
                      checked={this.state.AngPrev === "Si"}
                      onChange={this.ANGPRE.bind(this)}
                    />
                    <label htmlFor="angyes" className="yesno-alb-switch-label">
                      Si
                    </label>
                    <input
                      id="angno"
                      ref="angnotinput"
                      name="yesangno"
                      type="radio"
                      value="No"
                      className="yesno-alb-switch-input"
                      checked={this.state.AngPrev === "No"}
                      onChange={this.ANGPRE.bind(this)}
                    />
                    <label htmlFor="angno" className="yesno-alb-switch-label">
                      No
                    </label>
                  </div>
                  <div className="yesno-alb-container ynleft">
                    <input
                      id="albyes"
                      ref="albyesinput"
                      name="yesalbno"
                      type="radio"
                      value="Si"
                      className="yesno-alb-switch-input"
                      checked={this.state.selectedAlb === "Si"}
                      onChange={this.albuminuria.bind(this)}
                    />
                    <label htmlFor="albyes" className="yesno-alb-switch-label">
                      Si
                    </label>
                    <input
                      id="albno"
                      ref="albnotinput"
                      name="yesalbno"
                      type="radio"
                      value="No"
                      className="yesno-alb-switch-input"
                      checked={this.state.selectedAlb === "No"}
                      onChange={this.albuminuria.bind(this)}
                    />
                    <label htmlFor="albno" className="yesno-alb-switch-label">
                      No
                    </label>
                  </div>
                  <input
                    type="number"
                    ref="HbA1c"
                    id="HbA1c"
                    className={this.state.hba1cClass}
                    placeholder="0.00"
                    value={this.state.hba1c}
                    onChange={this.hba1cHandleChange.bind(this)}
                  />
                  <label className="severity-input severity-input-noeditable">
                    {sistolica}
                  </label>
                  <input
                    type="text"
                    ref="time"
                    id="time"
                    className={this.state.timeClass}
                    placeholder="# Años"
                    value={this.state.duracionDm}
                    onChange={this.duracionDmChange.bind(this)}
                  />
                  <label className="severity-input severity-input-noeditable">
                    {year - this.state.duracionDm}
                  </label>
                </div>
                <div className="diabetes-severity-content">
                  <div className="severity-data-labels-right">
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb" />
                    <label className="diabetes-data-label right-lb">mmHg</label>
                    <label className="diabetes-data-label right-lb">años</label>
                    <label className="diabetes-data-label right-lb" />
                  </div>
                </div>
              </div>
              <div className="validation-text-container">
                <span className="validation-medical">{this.state.textH}</span>
                <span className="validation-medical">
                  {this.state.textTime}
                </span>
              </div>
              <img className="diabetes-separator" src={MiddleLine} />
              <div className="diabetes-severity-data">
                <div className="diabetes-info-containers">
                  <div className="severity-title">
                    Puntaje de Severidad y Complicaciones (segun CIE-10)
                  </div>
                  <div className="diabetes-severity-content">
                    <div className="severity-data-labels-left">
                      {arrayDataLabels[0].labelsDiabetesThree.map(label => (
                        <label className="diabetes-data-label">{label}</label>
                      ))}
                    </div>
                    <div className="severity-data-labels-center">
                      <select
                        ref="ojos"
                        id="ojos"
                        className="severity-select"
                        value={this.state.ojosValue}
                        onChange={this.ojosHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].ojos.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                      <select
                        ref="rinon"
                        id="rinon"
                        className="severity-select"
                        value={this.state.rinonValue}
                        onChange={this.rinonHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].rinon.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                      <select
                        ref="neurop"
                        id="neurop"
                        className="severity-select"
                        value={this.state.neuroValue}
                        onChange={this.nueroHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].neurop.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                      <select
                        ref="cerebro"
                        id="cerebro"
                        className="severity-select"
                        value={this.state.cerebroValue}
                        onChange={this.cerebroHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].cerebro.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                      <select
                        ref="corazon"
                        id="corazon"
                        className="severity-select"
                        value={this.state.corazonValue}
                        onChange={this.corazonHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].corazon.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                      <select
                        ref="vper"
                        id="vper"
                        className="severity-select"
                        value={this.state.vascularValue}
                        onChange={this.vascularHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].vper.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                      <select
                        ref="metab"
                        id="metab"
                        className="severity-select"
                        value={this.state.metabValue}
                        onChange={this.metabHandleChange.bind(this)}
                      >
                        {arrayDataLabels[0].optionsDiabetes[0].metab.map(
                          label => (
                            <option value={label.value}>{label.content}</option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="diabetes-info-containers">
                  <div className="severity-title">Severidad</div>
                  <div className="severity-data-labels">
                    <label className="severity-label">
                      {this.state.ojosValue}
                    </label>
                    <label className="severity-label">
                      {this.state.rinonValue}
                    </label>
                    <label className="severity-label">
                      {this.state.neuroValue}
                    </label>
                    <label className="severity-label">
                      {this.state.cerebroValue}
                    </label>
                    <label className="severity-label">
                      {this.state.corazonValue}
                    </label>
                    <label className="severity-label">
                      {this.state.vascularValue}
                    </label>
                    <label className="severity-label">
                      {this.state.metabValue}
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-submit-btn-container btn-conditions btn-diabetes">
                {this.state.muerto ? (
                  ""
                ) : this.state.hba1c != "" &&
                  this.state.fase != "" &&
                  this.state.funcional != "" &&
                  tmpboolena ? (
                      <button
                        id="saveData"
                        className="form-submit-button save-button"
                        onClick={this.saveDiabetes.bind(this)}
                      >
                        Guardar{" "}
                      </button>
                    ) : (
                      ""
                    )}
              </div>
            </ReactModal>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/MedicalForm.js